const BuildMvp = () => {
  return (
    <svg
      width={102}
      height={102}
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.271 50.1496C98.271 52.11 98.0568 54.0623 97.5917 55.9595C97.4387 56.5837 97.2551 57.2059 97.045 57.8179C96.9838 57.9934 96.9226 58.1688 96.8573 58.3422C96.8042 58.485 96.7492 58.6278 96.6941 58.7686C96.6778 58.8073 96.6635 58.8461 96.6472 58.8848C96.588 59.0317 96.5288 59.1786 96.4656 59.3234C96.4554 59.3459 96.4452 59.3704 96.435 59.3948C96.3738 59.5376 96.3106 59.6804 96.2473 59.8212C96.2188 59.8844 96.1902 59.9456 96.1616 60.0068C96.1045 60.1333 96.0454 60.2578 95.9842 60.3822C95.9209 60.5148 95.8556 60.6454 95.7904 60.7759C95.7659 60.8228 95.7434 60.8698 95.719 60.9146C95.6618 61.0268 95.6027 61.139 95.5456 61.2512C95.4986 61.339 95.4517 61.4246 95.4048 61.5103C95.1886 61.9102 94.9621 62.3039 94.7255 62.6935C94.6296 62.8526 94.5317 63.0118 94.4317 63.1688C94.4093 63.2076 94.3848 63.2464 94.3603 63.2851C94.2461 63.4646 94.1298 63.6442 94.0115 63.8237C93.9156 63.9685 93.8197 64.1134 93.7198 64.2582C93.6341 64.3847 93.5484 64.5091 93.4607 64.6356C93.4423 64.6621 93.424 64.6886 93.4036 64.7152C93.3138 64.8457 93.22 64.9763 93.1282 65.1068C93.0139 65.268 92.8976 65.4251 92.7814 65.5842C92.7569 65.6168 92.7344 65.6495 92.71 65.6801C92.5774 65.8616 92.4407 66.0412 92.306 66.2186C92.2244 66.3247 92.1428 66.4328 92.0592 66.5369C91.9123 66.7307 91.7614 66.9224 91.6084 67.1142C91.4635 67.2978 91.3166 67.4794 91.1677 67.6609C91.1514 67.6813 91.1351 67.6997 91.1188 67.7201C90.9719 67.9016 90.825 68.0812 90.674 68.2607C90.6312 68.3158 90.5843 68.3708 90.5394 68.4239C90.4027 68.5891 90.264 68.7544 90.1253 68.9176C89.7254 69.3908 89.3215 69.86 88.9156 70.3252C88.0894 71.2758 87.2448 72.2203 86.3839 73.1587C85.6679 73.9339 84.9416 74.705 84.2011 75.4619C80.6474 79.1114 76.8 82.5162 72.616 85.2294C72.0958 85.566 71.5715 85.8944 71.0411 86.2066C70.8473 86.3208 70.6535 86.435 70.4597 86.5472C70.427 86.5656 70.3924 86.586 70.3597 86.6044C70.1598 86.7186 69.9599 86.8308 69.7579 86.941C69.5519 87.0552 69.3458 87.1674 69.1378 87.2755C69.0439 87.3245 68.9501 87.3735 68.8562 87.4224C68.4503 87.6346 68.0402 87.8386 67.6261 88.0344C67.4038 88.1405 67.1814 88.2425 66.957 88.3424C66.751 88.4363 66.5429 88.5281 66.3348 88.6178C66.2491 88.6546 66.1655 88.6913 66.0798 88.726C65.8901 88.8076 65.6983 88.8851 65.5066 88.9626C65.1373 89.1115 64.764 89.2543 64.3886 89.389C64.2458 89.442 64.101 89.493 63.9562 89.544C63.8746 89.5726 63.793 89.5991 63.7114 89.6276C63.5767 89.6725 63.4421 89.7174 63.3074 89.7602C63.1912 89.799 63.0728 89.8357 62.9566 89.8724C62.9525 89.8745 62.9484 89.8745 62.9443 89.8765C62.7138 89.9479 62.4833 90.0173 62.2528 90.0846C61.8876 90.1907 61.5224 90.2886 61.1552 90.3824C60.9125 90.4436 60.6697 90.5008 60.4249 90.5558C60.1944 90.6089 59.9639 90.6579 59.7313 90.7068C59.713 90.7109 59.6946 90.715 59.6762 90.717C59.4355 90.766 59.1928 90.8129 58.95 90.8557C58.8256 90.8782 58.7032 90.8986 58.5787 90.919C58.4543 90.9394 58.3298 90.9598 58.2034 90.9781C58.0912 90.9965 57.9769 91.0128 57.8647 91.0271C57.728 91.0475 57.5893 91.0658 57.4526 91.0842C56.0022 91.2698 54.5477 91.3474 53.0932 91.331C53.0054 91.331 52.9198 91.329 52.832 91.327C51.5142 91.3025 50.1964 91.2005 48.8846 91.0312C48.7888 91.0189 48.6929 91.0067 48.597 90.9924C48.4318 90.97 48.2665 90.9475 48.1013 90.923C47.9728 90.9026 47.8442 90.8822 47.7157 90.8618C47.171 90.7762 46.6304 90.6782 46.0898 90.5681C45.9695 90.5456 45.8512 90.5212 45.7328 90.4946C45.3697 90.4192 45.0046 90.3376 44.6435 90.2519C44.4007 90.1948 44.16 90.1356 43.9193 90.0744C43.7989 90.0438 43.6786 90.0132 43.5582 89.9806C43.4378 89.95 43.3175 89.9173 43.1971 89.8847C42.7177 89.7562 42.2404 89.6174 41.765 89.4726C41.2122 89.3053 40.6634 89.1278 40.1167 88.9402C39.9188 88.8728 39.7189 88.8035 39.521 88.7341C38.907 88.5158 38.293 88.2853 37.6871 88.0466C37.579 88.0038 37.4688 87.9589 37.3546 87.912C37.2668 87.8753 37.1791 87.8365 37.0873 87.7957C37.0282 87.7692 36.969 87.7427 36.9078 87.7141C36.512 87.5346 36.0816 87.3245 35.6185 87.0878C35.541 87.047 35.4614 87.0062 35.3819 86.9654C35.0983 86.8165 34.8025 86.6594 34.4986 86.4922C33.86 86.1413 33.1766 85.7537 32.4586 85.3314C24.2965 80.5293 11.8015 71.5165 8.86801 68.0995C8.71909 67.9261 8.57425 67.7507 8.42941 67.5732C8.31721 67.4345 8.20501 67.2937 8.09689 67.1509C7.99693 67.0224 7.89901 66.8939 7.80313 66.7613C7.71745 66.647 7.63381 66.5308 7.55221 66.4124C7.47469 66.3043 7.39717 66.1942 7.32169 66.084C7.31761 66.0758 7.31149 66.0677 7.30537 66.0595C7.21357 65.9228 7.12177 65.7862 7.03201 65.6474C6.94633 65.5148 6.86065 65.3822 6.77905 65.2476C6.73825 65.1844 6.69949 65.1191 6.66073 65.0538C6.56893 64.9028 6.47917 64.7519 6.39145 64.6009C6.39145 64.5989 6.39145 64.5989 6.38941 64.5968C6.29557 64.4296 6.20173 64.2623 6.10993 64.093C5.95081 63.7972 5.79781 63.4993 5.65501 63.1974C5.61829 63.1199 5.58157 63.0403 5.54485 62.9628C5.25517 62.3426 5.00017 61.7102 4.78189 61.0676C4.70233 60.8432 4.63093 60.6168 4.56157 60.3904C4.47385 60.0986 4.39429 59.8049 4.32085 59.5111C4.30657 59.452 4.29229 59.3948 4.28005 59.3357C4.24333 59.1827 4.20865 59.0276 4.17805 58.8726C4.13113 58.6564 4.09237 58.4401 4.05565 58.2218C4.04749 58.1688 4.03729 58.1158 4.03117 58.0627C4.01281 57.9505 3.99649 57.8383 3.98221 57.7241C3.96385 57.5894 3.94753 57.4528 3.93325 57.3181C3.92713 57.2712 3.92305 57.2263 3.91897 57.1814C3.90673 57.0652 3.89857 56.9489 3.88837 56.8346C3.88837 56.8244 3.88837 56.8142 3.88633 56.8061C3.87613 56.6674 3.86797 56.5307 3.86389 56.394C3.86185 56.3797 3.86185 56.3675 3.86185 56.3552C3.85573 56.2104 3.85165 56.0656 3.84961 55.9207C3.84961 55.8677 3.84961 55.8126 3.84961 55.7596C3.84961 55.6739 3.84961 55.5902 3.84961 55.5046C3.85165 55.2924 3.85777 55.0782 3.87205 54.866C3.88021 54.7273 3.89041 54.5886 3.90265 54.4519C3.92713 54.1786 3.95977 53.9052 4.00057 53.6339C4.02097 53.4952 4.04341 53.3564 4.06993 53.2198C4.11889 52.9444 4.17805 52.669 4.24741 52.3936C4.43101 51.6694 4.66561 50.9717 4.95121 50.3026C5.16745 49.7864 5.41225 49.2907 5.68357 48.8052C5.70397 48.7644 5.72845 48.7216 5.75293 48.6808C6.85249 46.7448 8.34781 45.0271 10.0328 43.4359C10.2124 43.2646 10.3939 43.0973 10.5796 42.932C10.7734 42.7546 10.9692 42.5812 11.1671 42.4057C11.1793 42.3955 11.1916 42.3833 11.2038 42.3731C11.52 42.0956 11.8403 41.8223 12.1646 41.551C12.6644 41.1328 13.1724 40.7227 13.6844 40.3147C13.7008 40.3004 13.7191 40.2882 13.7354 40.2739C14.174 39.9271 14.6167 39.5824 15.0574 39.2396C15.751 38.7031 16.4466 38.1686 17.128 37.6362C17.3095 37.4954 17.489 37.3547 17.6665 37.2139C17.8644 37.0589 18.0582 36.9038 18.252 36.7488C20.0798 35.2841 21.6547 33.7255 23.1194 32.1302C23.403 31.8202 23.6845 31.508 23.964 31.1939C24.0966 31.0429 24.2292 30.894 24.3598 30.743C26.2223 28.6214 27.9542 26.4754 29.882 24.4496C30.341 23.9662 30.8102 23.4908 31.2937 23.0237C31.7017 22.634 32.1158 22.2505 32.5463 21.8752C33.0379 21.4427 33.5438 21.0204 34.0742 20.6124C34.7984 20.0494 35.5614 19.5088 36.3774 18.9926C36.5773 18.8641 36.7752 18.7397 36.9751 18.6173C57.316 5.9754 72.2875 10.1023 82.2754 18.6173C83.0281 19.2558 83.7544 19.9229 84.45 20.6124C84.8743 21.0224 85.2844 21.4468 85.6822 21.8752C85.727 21.92 85.7678 21.967 85.8107 22.0159C86.0902 22.3138 86.3615 22.6136 86.6267 22.9156C86.7062 23.0053 86.7838 23.0951 86.8613 23.1848C86.9776 23.3195 87.0938 23.4541 87.2081 23.5908C87.3488 23.756 87.4876 23.9233 87.6263 24.0906C87.714 24.1967 87.7997 24.3028 87.8854 24.4088C88.4423 25.0943 88.9727 25.7899 89.4786 26.4896C89.5806 26.6284 89.6806 26.7691 89.7805 26.9099C90.4782 27.8891 91.1269 28.8785 91.7287 29.8618C91.8144 30.0025 91.9001 30.1433 91.9837 30.282C92.0694 30.4228 92.153 30.5635 92.2346 30.7043C92.3162 30.843 92.3978 30.9838 92.4774 31.1225C92.559 31.2632 92.6386 31.402 92.7161 31.5407C92.7936 31.6794 92.8711 31.8202 92.9486 31.9589C93.0282 32.0976 93.1037 32.2363 93.1751 32.373C93.2506 32.5117 93.324 32.6504 93.3974 32.7871C93.4709 32.9238 93.5423 33.0625 93.6137 33.1992C93.683 33.3359 93.7544 33.4726 93.8238 33.6072C93.8932 33.7439 93.9605 33.8806 94.0278 34.0152C94.295 34.5538 94.548 35.0862 94.7887 35.6105C94.907 35.8757 95.0254 36.1388 95.1376 36.3979C95.6455 37.5648 96.08 38.6807 96.435 39.719C96.437 39.7231 96.4391 39.7292 96.4391 39.7333C96.4738 39.8333 96.5064 39.9312 96.539 40.0291C96.5737 40.1311 96.6064 40.2311 96.639 40.331C96.6635 40.4086 96.69 40.484 96.7124 40.5616C96.7492 40.6758 96.7859 40.79 96.8206 40.9063C96.8593 41.0308 96.896 41.1552 96.9307 41.2796C96.998 41.5081 97.0633 41.7366 97.1245 41.9671C97.1776 42.1609 97.2286 42.3547 97.2775 42.5506C97.2877 42.5873 97.2979 42.622 97.3061 42.6587C97.3142 42.6893 97.3204 42.7199 97.3285 42.7505C97.3571 42.8647 97.3856 42.979 97.4122 43.0952C97.4856 43.3992 97.5529 43.7052 97.6162 44.0112C97.6508 44.1785 97.6855 44.3437 97.7161 44.511C97.7222 44.5416 97.7284 44.5722 97.7345 44.6048C97.7651 44.7619 97.7936 44.919 97.8202 45.0761C97.8569 45.2862 97.8916 45.4984 97.9222 45.7085C97.9487 45.8676 97.9711 46.0288 97.9936 46.1899C97.9956 46.2124 97.9997 46.2368 98.0038 46.2613C98.018 46.3674 98.0323 46.4755 98.0446 46.5836C98.0568 46.6734 98.067 46.7632 98.0772 46.8509C98.1139 47.1752 98.1466 47.4976 98.1731 47.8219C98.1792 47.8954 98.1853 47.9688 98.1914 48.0422C98.1996 48.1646 98.2078 48.2891 98.2159 48.4115C98.2241 48.5482 98.2322 48.6848 98.2384 48.8236C98.2445 48.9296 98.2486 49.0337 98.2526 49.1398C98.2588 49.2948 98.2628 49.4519 98.2649 49.6069C98.269 49.7864 98.271 49.968 98.271 50.1496Z"
        fill="#585550"
        fillOpacity="0.4"
      />
      <g opacity="0.7">
        <path
          d="M98.2701 50.1496C98.2701 52.11 98.0559 54.0623 97.5908 55.9595C97.4378 56.5837 97.2541 57.2059 97.044 57.8179C96.9828 57.9934 96.9216 58.1688 96.8563 58.3422C96.8033 58.485 96.7482 58.6278 96.6931 58.7686C96.6768 58.8073 96.6625 58.8461 96.6462 58.8848C96.5871 59.0317 96.5279 59.1786 96.4647 59.3234C96.4545 59.3459 96.4443 59.3704 96.4341 59.3948C96.3729 59.5376 96.3096 59.6804 96.2464 59.8212C96.2178 59.8844 96.1893 59.9456 96.1607 60.0068C96.1036 60.1333 96.0444 60.2578 95.9832 60.3822C95.92 60.5148 95.8547 60.6454 95.7894 60.7759C95.7649 60.8228 95.7425 60.8698 95.718 60.9146C95.6609 61.0268 95.6017 61.139 95.5446 61.2512C95.4977 61.339 95.4508 61.4246 95.4039 61.5103C95.1876 61.9102 94.9612 62.3039 94.7245 62.6935C94.6287 62.8526 94.5307 63.0118 94.4308 63.1688C94.4083 63.2076 94.3839 63.2464 94.3594 63.2851C94.2451 63.4646 94.1289 63.6442 94.0105 63.8237C93.9147 63.9685 93.8188 64.1134 93.7188 64.2582C93.6331 64.3847 93.5475 64.5091 93.4597 64.6356C93.4414 64.6621 93.423 64.6886 93.4026 64.7152C93.3129 64.8457 93.219 64.9763 93.1272 65.1068C93.013 65.268 92.8967 65.4251 92.7804 65.5842C92.7559 65.6168 92.7335 65.6495 92.709 65.6801C92.5764 65.8616 92.4398 66.0412 92.3051 66.2187C92.2235 66.3247 92.1419 66.4328 92.0583 66.5369C91.9114 66.7307 91.7604 66.9224 91.6074 67.1142C91.4626 67.2978 91.3157 67.4794 91.1668 67.6609C91.1505 67.6813 91.1341 67.6997 91.1178 67.7201C90.9709 67.9016 90.8241 68.0812 90.6731 68.2607C90.6303 68.3158 90.5834 68.3708 90.5385 68.4239C90.4018 68.5891 90.2631 68.7544 90.1244 68.9176C89.7245 69.3908 89.3206 69.8601 88.9146 70.3252C88.0884 71.2758 87.2439 72.2203 86.383 73.1587C85.6669 73.9339 84.9407 74.705 84.2002 75.4619C80.6465 79.1115 76.7991 82.5162 72.615 85.2294C72.0948 85.566 71.5705 85.8944 71.0401 86.2066C70.8463 86.3208 70.6525 86.435 70.4587 86.5472C70.4261 86.5656 70.3914 86.586 70.3588 86.6044C70.1589 86.7186 69.9589 86.8308 69.757 86.941C69.5509 87.0552 69.3449 87.1674 69.1368 87.2755C69.043 87.3245 68.9491 87.3735 68.8553 87.4224C68.4493 87.6346 68.0393 87.8386 67.6252 88.0344C67.4028 88.1405 67.1805 88.2425 66.9561 88.3424C66.75 88.4363 66.542 88.5281 66.3339 88.6179C66.2482 88.6546 66.1646 88.6913 66.0789 88.726C65.8891 88.8076 65.6974 88.8851 65.5056 88.9626C65.1364 89.1115 64.7631 89.2543 64.3877 89.389C64.2449 89.442 64.1001 89.493 63.9552 89.544C63.8736 89.5726 63.792 89.5991 63.7104 89.6276C63.5758 89.6725 63.4411 89.7174 63.3065 89.7603C63.1902 89.799 63.0719 89.8357 62.9556 89.8724C62.9515 89.8745 62.9475 89.8745 62.9434 89.8765C62.7129 89.9479 62.4823 90.0173 62.2518 90.0846C61.8867 90.1907 61.5215 90.2886 61.1543 90.3824C60.9115 90.4436 60.6688 90.5008 60.424 90.5558C60.1935 90.6089 59.9629 90.6579 59.7304 90.7068C59.712 90.7109 59.6937 90.715 59.6753 90.717C59.4346 90.766 59.1918 90.8129 58.9491 90.8557C58.8246 90.8782 58.7022 90.8986 58.5778 90.919C58.4533 90.9394 58.3289 90.9598 58.2024 90.9781C58.0902 90.9965 57.976 91.0128 57.8638 91.0271C57.7271 91.0475 57.5884 91.0658 57.4517 91.0842C56.0013 91.2698 54.5467 91.3474 53.0922 91.3311C53.0045 91.3311 52.9188 91.329 52.8311 91.327C51.5133 91.3025 50.1954 91.2005 48.8837 91.0312C48.7878 91.0189 48.6919 91.0067 48.5961 90.9924C48.4308 90.97 48.2656 90.9475 48.1003 90.923C47.9718 90.9027 47.8433 90.8822 47.7148 90.8618C47.1701 90.7762 46.6295 90.6782 46.0889 90.5681C45.9685 90.5456 45.8502 90.5212 45.7319 90.4947C45.3688 90.4192 45.0036 90.3376 44.6425 90.2519C44.3998 90.1948 44.1591 90.1356 43.9183 90.0744C43.798 90.0438 43.6776 90.0132 43.5573 89.9806C43.4369 89.95 43.3165 89.9173 43.1962 89.8847C42.7168 89.7562 42.2394 89.6175 41.7641 89.4726C41.2113 89.3053 40.6625 89.1278 40.1158 88.9402C39.9179 88.8728 39.718 88.8035 39.5201 88.7341C38.9061 88.5158 38.292 88.2853 37.6861 88.0467C37.578 88.0038 37.4679 87.9589 37.3536 87.912C37.2659 87.8753 37.1782 87.8365 37.0864 87.7957C37.0272 87.7692 36.9681 87.7427 36.9069 87.7141C36.5111 87.5346 36.0807 87.3245 35.6176 87.0878C35.5401 87.047 35.4605 87.0062 35.3809 86.9654C35.0974 86.8165 34.8016 86.6594 34.4976 86.4922C33.8591 86.1413 33.1757 85.7537 32.4576 85.3314C24.2956 80.5293 11.8006 71.5165 8.86707 68.0995C8.71815 67.9261 8.57331 67.7507 8.42847 67.5732C8.31627 67.4345 8.20407 67.2937 8.09595 67.1509C7.99599 67.0224 7.89807 66.8939 7.80219 66.7613C7.71651 66.647 7.63287 66.5308 7.55127 66.4124C7.47375 66.3043 7.39623 66.1942 7.32075 66.084C7.31667 66.0758 7.31055 66.0677 7.30443 66.0595C7.21263 65.9229 7.12083 65.7862 7.03107 65.6474C6.94539 65.5148 6.85971 65.3822 6.77811 65.2476C6.73731 65.1844 6.69855 65.1191 6.65979 65.0538C6.56799 64.9029 6.47823 64.7519 6.39051 64.6009C6.39051 64.5989 6.39051 64.5989 6.38847 64.5968C6.29463 64.4296 6.20079 64.2623 6.10899 64.093C5.94987 63.7972 5.79687 63.4993 5.65407 63.1974C5.61735 63.1199 5.58063 63.0403 5.54391 62.9628C5.25423 62.3427 4.99923 61.7102 4.78095 61.0676C4.70139 60.8432 4.62999 60.6168 4.56063 60.3904C4.47291 60.0986 4.39335 59.8049 4.31991 59.5111C4.30563 59.452 4.29135 59.3948 4.27911 59.3357C4.24239 59.1827 4.20771 59.0276 4.17711 58.8726C4.13019 58.6564 4.08939 58.4401 4.05471 58.2218C4.04655 58.1688 4.03635 58.1158 4.03023 58.0627C4.01187 57.9505 3.99555 57.8383 3.98127 57.7241C3.96291 57.5894 3.94659 57.4528 3.93231 57.3181C3.92619 57.2712 3.92211 57.2263 3.91803 57.1814C3.90579 57.0652 3.89763 56.9489 3.88743 56.8346C3.88743 56.8244 3.88743 56.8142 3.88539 56.8061C3.87519 56.6674 3.86703 56.5307 3.86295 56.394C3.86091 56.3797 3.86091 56.3675 3.86091 56.3552C3.85479 56.2104 3.85071 56.0656 3.84867 55.9207C3.84255 55.5678 3.85071 55.2169 3.87111 54.866C3.87927 54.7273 3.88947 54.5886 3.90171 54.4519C3.92619 54.1786 3.95883 53.9052 3.99963 53.6339C4.02003 53.4952 4.04247 53.3564 4.06899 53.2198C4.11795 52.9444 4.17711 52.669 4.24647 52.3936C4.43007 51.6694 4.66467 50.9717 4.95027 50.3026C5.16651 49.7864 5.41131 49.2907 5.68263 48.8052C5.70303 48.7644 5.72751 48.7216 5.75199 48.6808C6.85155 46.7448 8.34687 45.0271 10.0319 43.4359C10.1278 43.3441 10.2237 43.2544 10.3216 43.1646C10.4073 43.0871 10.4929 43.0096 10.5786 42.932C10.7724 42.7546 10.9683 42.5812 11.1661 42.4057C11.1784 42.3955 11.1906 42.3833 11.2029 42.3731C11.5191 42.0956 11.8393 41.8223 12.1637 41.551C12.6635 41.1328 13.1715 40.7227 13.6835 40.3147C13.6998 40.3004 13.7182 40.2882 13.7345 40.2739C14.1731 39.9271 14.6158 39.5824 15.0564 39.2396C15.2788 39.0683 15.4991 38.8969 15.7215 38.7256C16.1927 38.3624 16.6639 37.9993 17.127 37.6362C17.3086 37.4954 17.4881 37.3547 17.6656 37.2139C17.8635 37.0589 18.0573 36.9038 18.2511 36.7488C20.0789 35.2841 21.6538 33.7255 23.1185 32.1302C23.4021 31.8202 23.6836 31.508 23.9631 31.1939C24.0957 31.0429 24.2283 30.894 24.3588 30.743C26.2213 28.6214 27.9533 26.4754 29.8811 24.4496C30.3401 23.9662 30.8093 23.4908 31.2928 23.0237C31.7008 22.634 32.1149 22.2505 32.5453 21.8752C33.037 21.4427 33.5429 21.0204 34.0733 20.6124C34.7975 20.0494 35.5605 19.5088 36.3765 18.9926C36.5764 18.8641 36.7743 18.7397 36.9742 18.6173C57.315 5.9754 72.2866 10.1023 82.2744 18.6173C83.0272 19.2558 83.7534 19.9229 84.4491 20.6124C84.8734 21.0224 85.2834 21.4468 85.6812 21.8752C85.7261 21.92 85.7669 21.967 85.8097 22.0159C86.0892 22.3138 86.3605 22.6136 86.6257 22.9156C86.7053 23.0053 86.7828 23.0951 86.8604 23.1848C86.9766 23.3195 87.0929 23.4541 87.2071 23.5908C87.3479 23.756 87.4866 23.9233 87.6253 24.0906C87.7131 24.1967 87.7987 24.3028 87.8844 24.4088C88.4413 25.0943 88.9717 25.7899 89.4777 26.4896C89.5797 26.6284 89.6796 26.7691 89.7796 26.9099C90.4773 27.8891 91.126 28.8785 91.7278 29.8618C91.8135 30.0025 91.8991 30.1433 91.9828 30.282C92.0685 30.4228 92.1521 30.5635 92.2337 30.7043C92.3153 30.843 92.3969 30.9838 92.4765 31.1225C92.5581 31.2632 92.6376 31.402 92.7151 31.5407C92.7927 31.6794 92.8702 31.8202 92.9477 31.9589C93.0273 32.0976 93.1027 32.2363 93.1741 32.373C93.2496 32.5117 93.3231 32.6504 93.3965 32.7871C93.4699 32.9238 93.5414 33.0625 93.6127 33.1992C93.6821 33.3359 93.7535 33.4726 93.8229 33.6072C93.8922 33.7439 93.9595 33.8806 94.0269 34.0152C94.2962 34.5538 94.5491 35.0862 94.7878 35.6105C94.9061 35.8757 95.0244 36.1388 95.1366 36.3979C95.6446 37.5648 96.0791 38.6807 96.4341 39.719C96.4361 39.7231 96.4381 39.7292 96.4381 39.7333C96.4728 39.8333 96.5055 39.9312 96.5381 40.0291C96.5728 40.1311 96.6054 40.2311 96.6381 40.331C96.6626 40.4086 96.6891 40.484 96.7115 40.5616C96.7482 40.6758 96.7849 40.79 96.8196 40.9063C96.8584 41.0308 96.8951 41.1552 96.9298 41.2796C96.9971 41.5081 97.0624 41.7366 97.1236 41.9671C97.1766 42.1609 97.2276 42.3547 97.2766 42.5506C97.2868 42.5873 97.297 42.622 97.3051 42.6587C97.3133 42.6893 97.3194 42.7199 97.3276 42.7505C97.3561 42.8647 97.3847 42.979 97.4112 43.0952C97.4847 43.3992 97.552 43.7052 97.6152 44.0112C97.6499 44.1785 97.6846 44.3437 97.7152 44.511C97.7213 44.5416 97.7274 44.5722 97.7336 44.6048C97.7642 44.7619 97.7927 44.919 97.8192 45.0761C97.8559 45.2862 97.8906 45.4984 97.9212 45.7085C97.9477 45.8676 97.9702 46.0288 97.9926 46.1899C97.9947 46.2124 97.9987 46.2368 98.0028 46.2613C98.0171 46.3674 98.0314 46.4755 98.0436 46.5836C98.0559 46.6734 98.0661 46.7632 98.0763 46.8509C98.113 47.1752 98.1456 47.4976 98.1721 47.8219C98.1783 47.8954 98.1844 47.9688 98.1905 48.0422C98.1987 48.1646 98.2068 48.2891 98.215 48.4115C98.2232 48.5482 98.2313 48.6848 98.2374 48.8236C98.2435 48.9296 98.2476 49.0337 98.2517 49.1398C98.2578 49.2948 98.2619 49.4519 98.2639 49.6069C98.268 49.7864 98.2701 49.968 98.2701 50.1496Z"
          fill="white"
        />
      </g>
      <path
        opacity="0.2"
        d="M6.5587 53.5024C6.51412 53.4734 6.52527 53.4533 6.5587 53.5024V53.5024Z"
        fill="#242424"
      />
      <path
        opacity="0.2"
        d="M25.6355 51.703C25.4275 53.0902 24.4034 54.2183 23.0713 54.6549L22.5653 54.8201C20.7457 57.3966 17.5551 58.4962 14.8358 56.8989L14.0402 56.4317L11.8125 53.7838C11.8043 53.7858 11.7941 53.7879 11.786 53.7899C11.0801 53.9368 10.2825 53.8287 9.76025 53.3309C9.67661 53.7675 9.10745 54.0245 8.72597 53.8001C8.34449 53.5757 8.29553 52.9515 8.63621 52.6679C8.18741 53.0637 7.49381 52.8821 7.06133 52.4496C7.04297 51.2685 7.16741 50.0873 7.45913 48.9225C7.64273 48.1983 7.87733 47.5006 8.16293 46.8315C8.37917 46.3154 8.62397 45.8196 8.89529 45.3341C8.91569 45.2933 8.94017 45.2505 8.96465 45.2097C9.36653 44.4998 9.82145 43.8204 10.3213 43.1656C10.4069 43.0881 10.4926 43.0106 10.5783 42.933C10.7721 42.7556 10.9679 42.5822 11.1658 42.4067C11.1781 42.3965 11.1903 42.3843 11.2025 42.3741C11.5187 42.0966 11.839 41.8233 12.1634 41.552C12.6632 41.1338 13.1711 40.7237 13.6832 40.3157C13.6995 40.3014 13.7179 40.2892 13.7342 40.2749C14.1728 39.9281 14.6155 39.5834 15.0561 39.2406C15.2785 39.0693 15.4988 38.8979 15.7211 38.7266C15.8558 38.7429 15.9863 38.7735 16.1128 38.8184C16.6575 39.0081 16.7513 39.5079 17.1287 39.8506C17.6306 40.3096 18.112 39.5385 18.8852 39.563C21.2618 39.6364 20.3397 42.0742 21.5005 41.7682C26.5127 40.4463 25.6702 46.858 23.4915 48.2656C24.7767 49.3305 25.8844 50.0343 25.6355 51.703Z"
        fill="black"
      />
      <path
        d="M14.859 57.7971C19.5279 57.7971 23.3128 54.0588 23.3128 49.4474C23.3128 44.836 19.5279 41.0977 14.859 41.0977C10.1901 41.0977 6.40527 44.836 6.40527 49.4474C6.40527 54.0588 10.1901 57.7971 14.859 57.7971Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M14.8595 56.7227C19.116 56.7227 22.5666 53.3141 22.5666 49.1094C22.5666 44.9047 19.116 41.4961 14.8595 41.4961C10.6029 41.4961 7.15234 44.9047 7.15234 49.1094C7.15234 53.3141 10.6029 56.7227 14.8595 56.7227Z"
        fill="#242424"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M6.5764 52.1101C6.09088 52.412 5.95216 53.4259 6.33568 53.8665C6.7192 54.3031 7.44952 53.9665 7.59844 53.281C7.66984 53.4728 7.89424 53.5034 8.01052 53.3381C8.09212 53.2198 8.0962 53.0362 8.03908 52.9097C8.00236 52.8791 8.01664 52.8567 8.03908 52.9097C8.28796 53.1076 8.71636 52.8914 8.77552 52.4711C8.59396 53.5931 9.61396 54.5723 10.3647 54.0011C10.1423 54.4785 10.434 55.1048 10.8216 55.2251C11.2092 55.3455 11.6254 55.117 11.9967 54.862C12.368 54.607 12.7474 54.3173 13.1534 54.299C13.5083 54.2827 13.8347 54.4826 14.1713 54.6009C15.2444 54.9742 16.501 54.4785 17.3211 53.3545C17.8637 54.2827 19.1999 53.942 19.559 52.7853C19.6344 53.3259 20.0037 53.738 20.4178 53.7441C20.8299 53.7502 21.2481 53.3483 21.3888 52.8098V52.8159C21.397 53.3279 21.854 53.5789 22.1804 53.2484C22.5965 52.8281 22.8556 52.057 22.6516 51.4389C23.2085 51.4165 23.745 50.7718 23.8307 50.0252C23.9164 49.2785 23.539 48.5299 23.0025 48.383C23.9225 48.0015 24.6447 46.7469 24.6794 45.4678C24.712 44.1908 24.0551 43.0015 23.1514 42.7036C22.8066 42.5894 22.4048 42.6118 22.113 42.9199C22.0049 42.1916 21.6744 41.5408 21.1889 41.2144C20.4137 40.6901 19.3346 41.0492 18.7572 42.0243C19.0388 41.5204 19.0571 40.7921 18.8021 40.3148C18.5451 39.8395 18.0371 39.6477 17.6046 39.8741C17.5108 39.0928 16.909 38.5379 16.3194 38.6889C15.7319 38.8399 15.2546 39.6763 15.3056 40.4657C15.2505 39.8293 14.4998 39.6722 14.2284 40.2067C14.2509 40.2556 14.2162 40.2271 14.2284 40.2067C13.8531 39.4192 13.0901 39.0153 12.3822 39.2458C11.6295 39.4927 10.9971 40.4392 10.9012 41.4694C10.381 40.9961 9.62416 41.0165 9.06724 41.5204C8.51032 42.0223 8.188 42.977 8.28592 43.8317C7.70044 43.2544 6.71512 43.5686 6.31324 44.4621C5.91136 45.3556 6.1888 46.6225 6.86608 46.9958C6.39892 47.0672 5.98684 47.6873 5.98684 48.3157C5.98888 48.946 6.40096 49.4825 6.87016 49.4662C6.39688 49.507 5.95216 50.066 5.8828 50.7004C5.80528 51.3349 6.12148 51.9713 6.5764 52.1101Z"
        fill="#E5796E"
      />
      <g opacity="0.2">
        <path
          d="M14.3479 49.1823C14.1113 48.9844 13.8094 48.8885 13.5217 48.9783C13.2341 49.068 12.9689 49.3679 12.9036 49.7372C12.8383 50.1064 13.0077 50.5144 13.2912 50.5838C13.636 50.6694 13.9889 50.2839 14.3398 50.3267C14.4642 50.341 14.5785 50.4104 14.7009 50.445C15.2047 50.5858 15.7127 50.135 16.1411 49.7086C16.2921 49.5597 16.4451 49.4046 16.5471 49.2006C16.6491 48.9966 16.6919 48.7274 16.6021 48.5295C16.4777 48.2541 16.1717 48.2316 15.9167 48.2847C15.4026 48.3908 14.9049 48.6845 14.4948 49.1211C14.5091 49.0191 14.5254 48.915 14.5397 48.811L14.3479 49.1823Z"
          fill="white"
        />
        <path
          d="M21.7162 48.1795C21.5816 48.0653 21.4408 47.949 21.2797 47.9102C21.1165 47.8715 20.9247 47.9265 20.8186 48.102C20.6738 48.3407 20.7554 48.6977 20.9329 48.869C21.1083 49.0404 21.347 49.0771 21.5734 49.1077C21.806 49.1403 22.0997 49.1322 22.2201 48.8629C22.3078 48.6671 22.2446 48.4182 22.1222 48.2754C21.9998 48.1326 21.8305 48.0714 21.6693 48.0143L21.7162 48.1795Z"
          fill="white"
        />
        <path
          d="M10.1814 44.0111C9.70808 44.2885 9.3368 44.8638 9.2144 45.5044C9.17768 45.6982 9.17768 45.9368 9.30824 46.0307C9.40004 46.096 9.51836 46.0592 9.62648 46.0205C10.0773 45.8573 10.5302 45.6941 10.981 45.5309C10.7648 45.6492 10.5424 45.7716 10.367 45.9797C10.1916 46.1857 10.0712 46.4978 10.1222 46.7794C10.1814 47.1098 10.4649 47.2975 10.7362 47.2771C11.0076 47.2547 11.2626 47.069 11.4849 46.8548C11.7236 46.6264 11.9582 46.3142 11.9684 45.947C11.9806 45.5778 11.6216 45.2596 11.3972 45.5084C11.9133 45.2983 12.409 44.9842 12.8578 44.5802C13.021 44.4334 13.1802 44.2702 13.2862 44.056C13.3903 43.8397 13.4311 43.5623 13.3413 43.3522C12.9007 42.3138 12.2907 43.9132 12.0031 44.0702C11.4604 44.366 10.8688 43.6072 10.1814 44.0111Z"
          fill="white"
        />
        <path
          d="M8.00301 48.6945C7.95201 48.9067 7.98057 49.1556 8.11113 49.282C8.24169 49.4085 8.47833 49.3494 8.54361 49.1433C8.24169 49.282 7.91733 49.4391 7.72353 49.7737C7.52973 50.1082 7.56645 50.6692 7.86429 50.7753C8.04993 50.8426 8.25189 50.7121 8.42529 50.5815C8.91897 50.2123 9.39225 49.792 9.83901 49.3269C9.69825 49.7288 10.0124 50.1552 10.347 50.1715C10.6815 50.1878 10.9977 49.9369 11.2894 49.6982C11.6464 49.4044 12.0585 48.9618 11.9749 48.4558C11.9014 48.0152 11.4588 47.8438 11.112 47.9968C10.7652 48.1478 10.5 48.5191 10.2531 48.872C10.449 48.5089 10.1899 48.005 9.85941 47.9683C9.53913 47.9316 9.21273 48.2008 9.00873 48.515C9.38817 48.2294 9.48405 47.5419 8.98425 47.493C8.65785 47.4624 8.08869 48.3416 8.00301 48.6945Z"
          fill="white"
        />
        <path
          d="M18.3133 46.5291C18.0338 46.4107 17.6748 46.6678 17.5911 47.0452C17.5075 47.4226 17.7196 47.8347 18.0175 47.8755C17.7972 47.9122 17.585 48.0652 17.4402 48.2896C17.3586 48.414 17.2974 48.5711 17.3116 48.7261C17.3341 48.9567 17.5238 49.0954 17.7074 49.0933C17.891 49.0913 18.0664 48.9811 18.2358 48.873C18.0542 48.9057 17.8624 48.9444 17.7156 49.0954C17.5687 49.2463 17.5014 49.5503 17.6278 49.7053C17.7339 49.8359 17.9114 49.8012 18.0583 49.74C18.3888 49.6033 18.6988 49.3647 18.9518 49.0525C19.1334 49.3055 19.4067 49.4789 19.6842 49.4034C19.9596 49.33 20.2003 48.9403 20.1207 48.6078C20.0636 48.3712 19.8678 48.2304 19.6719 48.2121C19.474 48.1937 19.2762 48.2753 19.0844 48.3651C19.2802 48.1774 19.4904 47.9693 19.5658 47.6755C19.6413 47.3818 19.4965 47.0044 19.2578 47.0411C18.9906 47.0839 18.8457 47.5552 18.6336 47.7347C18.3786 47.4389 18.8763 46.7637 18.3133 46.5291Z"
          fill="white"
        />
        <path
          d="M13.5369 45.41C13.2289 45.6894 13.1146 46.2117 13.1269 46.6768C13.1411 47.1888 13.3145 47.7274 13.6797 47.911C14.1611 48.1517 14.7793 47.5989 14.8813 46.9257C14.9833 46.2525 14.6507 45.5936 14.1856 45.31C14.1877 45.312 13.8449 45.1305 13.5369 45.41Z"
          fill="white"
        />
        <path
          d="M16.9475 44.6473C16.9883 44.6902 17.0291 44.7351 17.0699 44.7779C16.87 44.4576 16.4334 44.4393 16.1846 44.7432C15.9336 45.0451 15.9234 45.6041 16.1601 45.8795C16.3988 46.1549 16.8353 46.0876 17.0495 45.7428C17.3963 45.9284 17.8614 45.8203 18.1164 45.4246C18.3714 45.0288 18.3266 44.3699 17.994 44.1455C17.6615 43.9231 17.1413 44.3189 17.1699 44.8085C17.123 44.7432 17.074 44.6759 17.0271 44.6106L16.9475 44.6473Z"
          fill="white"
        />
        <path
          d="M20.6883 45.1916C20.4415 45.5078 20.1865 45.8464 20.0906 46.2667C19.9947 46.6869 20.1314 47.2071 20.4558 47.2948C20.7781 47.3805 21.0943 47.0194 21.286 46.6522C21.4594 46.3197 21.5941 45.9117 21.5043 45.5506C21.4146 45.1895 21.0045 44.9978 20.7924 45.2936L20.6883 45.1916Z"
          fill="white"
        />
        <path
          d="M15.324 43.009C15.2077 42.6683 14.8221 42.5704 14.563 42.7866C14.304 43.0049 14.202 43.4639 14.308 43.8127C14.4121 44.1616 14.6936 44.3839 14.9914 44.4064C15.3586 44.4349 15.8034 44.029 15.7279 43.572C15.8829 43.8291 16.1665 43.9188 16.4276 43.8699C16.6908 43.8209 16.9356 43.6536 17.1681 43.4741C17.4823 43.2273 17.8189 42.856 17.7944 42.4051C17.774 42.0461 17.5068 41.7829 17.2232 41.7666C16.9396 41.7503 16.6581 41.9359 16.4378 42.1848C16.2644 42.3807 16.1196 42.6173 15.9319 42.7907C15.7442 42.9641 15.4933 43.0661 15.2995 42.9437L15.324 43.009Z"
          fill="white"
        />
      </g>
      <path
        d="M76.7754 55.6445H29.7188V75.4631H76.7754V55.6445Z"
        fill="#E5796E"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.128 56.8438H30.7012V59.2938H35.128V56.8438Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M75.6856 68.7891H68.7129V71.2391H75.6856V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M75.6853 59.9023H71.3809V62.3524H75.6853V59.9023Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M35.128 65.7695H30.7012V68.2196H35.128V65.7695Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M34.2855 62.8164H30.7012V65.2664H34.2855V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1512 59.832H30.7012V62.2821H33.1512V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M36.2811 59.832H33.8311V62.2821H36.2811V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M39.408 59.832H36.958V62.2821H39.408V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M42.535 59.832H40.085V62.2821H42.535V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M45.6639 59.832H43.2139V62.2821H45.6639V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M48.7909 59.832H46.3408V62.2821H48.7909V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M51.9198 59.832H49.4697V62.2821H51.9198V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M55.0487 59.832H52.5986V62.2821H55.0487V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M58.1756 59.832H55.7256V62.2821H58.1756V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M61.3026 59.832H58.8525V62.2821H61.3026V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M64.4325 59.832H61.9824V62.2821H64.4325V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M67.5594 59.832H65.1094V62.2821H67.5594V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M70.6893 59.832H68.2393V62.2821H70.6893V59.832Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1512 71.8125H30.7012V74.2625H33.1512V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M36.2811 71.8125H33.8311V74.2625H36.2811V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M39.408 71.8125H36.958V74.2625H39.408V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M43.0756 71.8125H40.085V74.2625H43.0756V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M58.7163 71.8125H43.7529V74.2625H58.7163V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M66.1971 71.8125H63.7471V74.2625H66.1971V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M69.3241 71.8125H66.874V74.2625H69.3241V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M72.4579 71.8125H70.0078V74.2625H72.4579V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M63.1327 71.8125H59.3281V74.2625H63.1327V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M75.6854 71.8125H73.2354V74.2625H75.6854V71.8125Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M37.4315 62.8164H34.9814V65.2664H37.4315V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M40.5584 62.8164H38.1084V65.2664H40.5584V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M43.6883 62.8164H41.2383V65.2664H43.6883V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M46.8153 62.8164H44.3652V65.2664H46.8153V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M49.9442 62.8164H47.4941V65.2664H49.9442V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M53.0711 62.8164H50.6211V65.2664H53.0711V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M56.2 62.8164H53.75V65.2664H56.2V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M59.3289 62.8164H56.8789V65.2664H59.3289V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M62.4559 62.8164H60.0059V65.2664H62.4559V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M65.5828 62.8164H63.1328V65.2664H65.5828V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M68.7127 62.8164H66.2627V65.2664H68.7127V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M71.8397 62.8164H69.3896V65.2664H71.8397V62.8164Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M75.6857 62.8164V68.255H73.2357V65.2664H72.5176V62.8164H75.6857Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M38.1493 65.8047H35.6992V68.2547H38.1493V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M41.2762 65.8047H38.8262V68.2547H41.2762V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M44.4041 65.8047H41.9541V68.2547H44.4041V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M47.533 65.8047H45.083V68.2547H47.533V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M50.661 65.8047H48.2109V68.2547H50.661V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M53.7889 65.8047H51.3389V68.2547H53.7889V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M56.9178 65.8047H54.4678V68.2547H56.9178V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M60.0448 65.8047H57.5947V68.2547H60.0448V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M63.1737 65.8047H60.7236V68.2547H63.1737V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M66.3006 65.8047H63.8506V68.2547H66.3006V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M69.4276 65.8047H66.9775V68.2547H69.4276V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M72.5575 65.8047H70.1074V68.2547H72.5575V65.8047Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M36.8192 68.7891H34.3691V71.2391H36.8192V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M39.9461 68.7891H37.4961V71.2391H39.9461V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M43.076 68.7891H40.626V71.2391H43.076V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M46.203 68.7891H43.7529V71.2391H46.203V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M49.3309 68.7891H46.8809V71.2391H49.3309V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M52.4588 68.7891H50.0088V71.2391H52.4588V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M55.5877 68.7891H53.1377V71.2391H55.5877V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M58.7166 68.7891H56.2666V71.2391H58.7166V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M61.8436 68.7891H59.3936V71.2391H61.8436V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M64.9705 68.7891H62.5205V71.2391H64.9705V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M68.1004 68.7891H65.6504V71.2391H68.1004V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M38.1493 56.9922H35.6992V59.4422H38.1493V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M41.2762 56.9922H38.8262V59.4422H41.2762V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M44.4041 56.9922H41.9541V59.4422H44.4041V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M47.533 56.9922H45.083V59.4422H47.533V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M50.661 56.9922H48.2109V59.4422H50.661V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M53.7889 56.9922H51.3389V59.4422H53.7889V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M56.9178 56.9922H54.4678V59.4422H56.9178V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M60.0448 56.9922H57.5947V59.4422H60.0448V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M63.1737 56.9922H60.7236V59.4422H63.1737V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M66.3006 56.9922H63.8506V59.4422H66.3006V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M69.4276 56.9922H66.9775V59.4422H69.4276V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M72.5575 56.9922H70.1074V59.4422H72.5575V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M75.6854 56.9922H73.2354V59.4422H75.6854V56.9922Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M33.6694 68.7891H30.7012V71.2391H33.6694V68.7891Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M29.7188 55.7717L30.702 55.4453H76.1369L76.7836 55.7676L29.7188 55.7717Z"
        fill="#242424"
      />
      <path
        opacity="0.2"
        d="M63.3065 89.7601L62.3497 83.9971C62.1396 83.1383 61.6887 82.3569 61.0543 81.7409C59.151 79.9049 56.6357 78.0199 56.5275 75.6127C56.3623 71.9346 55.7891 72.0447 55.8503 71.1369C55.8523 71.1043 56.1359 70.6983 56.5051 69.7905C56.6234 69.4968 56.703 69.0602 56.7825 68.7012C56.8641 68.3238 57.2232 68.0668 57.6067 68.1198C57.8637 68.1545 58.1167 68.2708 58.2983 68.4442C58.6471 68.7828 58.8021 69.2826 58.8164 69.7702C58.8307 70.2557 58.7226 70.7371 58.6124 71.2104C58.9551 71.9774 59.1163 72.9097 59.2265 73.742C59.4447 73.0688 59.61 72.3895 59.8283 71.7183C59.8731 71.6939 59.8568 71.6408 59.8997 71.6164C59.5916 70.9554 59.8527 70.9921 59.2428 69.5376C58.2167 67.0896 57.0722 64.7293 56.2542 61.653C56.1889 61.4143 56.193 61.0226 56.2725 60.788C56.5683 59.9088 57.4741 60.1108 57.8699 60.6228C57.9759 60.7574 58.0535 60.9084 58.1147 61.0675C58.5329 62.163 59.4243 63.8521 60.0669 64.8313L62.2885 68.2177C62.2885 68.2177 63.0617 67.5833 63.18 67.2997L63.182 67.2977C63.2983 67.0121 63.3554 64.713 63.3554 64.713C63.3554 64.713 63.18 65.1434 62.7903 65.1189C62.5088 65.0985 61.9376 65.2618 61.5317 64.8048C61.1991 64.4315 61.1991 63.8705 61.4949 63.4706L62.5007 62.112C62.5007 62.112 63.1759 61.5204 64.0796 61.9223C64.9813 62.3262 65.8565 63.1667 65.8565 63.1667C65.8565 63.1667 66.6929 63.1238 67.4028 63.4645C68.1147 63.8072 68.8614 64.7905 68.8614 64.7905C68.8614 64.7905 69.6917 64.8415 70.065 65.1128C70.1588 65.1801 71.4257 67.1528 70.9687 68.6889C70.6974 69.6049 70.5301 70.935 70.4077 71.292L69.7855 80.2863L71.0401 86.2064L68.3575 87.7017C67.3701 88.2525 66.3379 88.7136 65.271 89.0828L63.3065 89.7601Z"
        fill="black"
      />
      <path
        d="M70.9239 79.2506L70.9484 70.2338C71.0463 69.8686 71.1259 68.5304 71.3339 67.5981C71.6869 66.0354 70.2935 64.1505 70.1936 64.0893C69.8019 63.8445 68.9716 63.8486 68.9716 63.8486C68.9716 63.8486 68.1617 62.9163 67.4273 62.6225C66.697 62.3308 65.8647 62.4287 65.8647 62.4287C65.8647 62.4287 64.9365 61.6474 64.0083 61.3047C63.0801 60.964 62.4457 61.5985 62.4457 61.5985L61.5338 63.0203C61.2645 63.4385 61.3033 63.9995 61.6582 64.3504C62.0948 64.7808 62.6537 64.5789 62.9353 64.5789C63.3269 64.5789 63.4718 64.1382 63.4718 64.1382C63.4718 64.1382 63.5677 66.4353 63.4718 66.727L63.4697 66.7291C63.3698 67.0208 62.6395 67.7042 62.6395 67.7042L60.1996 64.4728C59.4917 63.5385 58.4901 61.9126 58.0005 60.8477C57.9291 60.6927 57.8414 60.5458 57.7251 60.4193C57.2967 59.9338 56.3807 59.793 56.1421 60.6906C56.0788 60.9314 56.1013 61.321 56.1808 61.5556C57.2029 64.5707 58.5003 66.8494 59.6855 69.224C60.3914 70.6336 60.1282 70.6173 60.4811 71.2538C60.4403 71.2823 60.4587 71.3354 60.4159 71.3598C60.2425 72.0453 60.1241 72.7328 59.9507 73.4182C59.7855 72.5961 59.5631 71.676 59.1694 70.9335C59.249 70.4541 59.3245 69.9665 59.2755 69.481C59.2306 68.9955 59.0429 68.5079 58.6717 68.1938C58.4799 68.0326 58.2188 67.9347 57.9597 67.9163C57.5741 67.8878 57.2335 68.1693 57.1763 68.5508C57.1213 68.9139 57.0723 69.3545 56.9703 69.6544C56.6623 70.5847 56.4073 71.0069 56.4073 71.0396C56.4073 71.9494 56.9703 71.8005 57.3803 75.4623C57.6986 78.3122 61.3706 80.1971 63.3698 82.2555L65.4995 88.9569C67.972 87.9654 70.3384 86.6966 72.6089 85.2237L70.9239 79.2506Z"
        fill="white"
      />
      <path
        d="M69.8798 66.9948C69.9879 66.7296 70.1165 66.4563 70.349 66.287C70.5816 66.1176 70.9447 66.0972 71.1303 66.3155C70.9773 65.8484 70.8162 65.3832 70.6448 64.9222C70.5143 64.5713 70.3674 64.2062 70.0777 63.9675C69.788 63.7308 69.3107 63.6798 69.0618 63.9614C69.2393 65.0262 69.2576 66.1156 69.1189 67.1846C69.0434 67.7639 68.9455 68.429 69.3372 68.8655C69.4453 68.9532 69.6309 68.7962 69.5636 68.6758C69.531 68.6187 69.4167 68.6146 69.3657 68.6207C69.4881 68.0658 69.6636 67.5212 69.8798 66.9948Z"
        fill="#E5796E"
      />
      <path
        d="M69.8798 66.9948C69.9879 66.7296 70.1165 66.4563 70.349 66.287C70.5816 66.1176 70.9447 66.0972 71.1303 66.3155C70.9773 65.8484 70.8162 65.3832 70.6448 64.9222C70.5143 64.5713 70.3674 64.2062 70.0777 63.9675C69.788 63.7308 69.3107 63.6798 69.0618 63.9614C69.2393 65.0262 69.2576 66.1156 69.1189 67.1846C69.0434 67.7639 68.9455 68.429 69.3372 68.8655C69.4453 68.9532 69.6309 68.7962 69.5636 68.6758C69.531 68.6187 69.4167 68.6146 69.3657 68.6207C69.4881 68.0658 69.6636 67.5212 69.8798 66.9948Z"
        fill="#E5796E"
      />
      <path
        opacity="0.5"
        d="M69.8798 66.9948C69.9879 66.7296 70.1165 66.4563 70.349 66.287C70.5816 66.1176 70.9447 66.0972 71.1303 66.3155C70.9773 65.8484 70.8162 65.3832 70.6448 64.9222C70.5143 64.5713 70.3674 64.2062 70.0777 63.9675C69.788 63.7308 69.3107 63.6798 69.0618 63.9614C69.2393 65.0262 69.2576 66.1156 69.1189 67.1846C69.0434 67.7639 68.9455 68.429 69.3372 68.8655C69.4453 68.9532 69.6309 68.7962 69.5636 68.6758C69.531 68.6187 69.4167 68.6146 69.3657 68.6207C69.4881 68.0658 69.6636 67.5212 69.8798 66.9948Z"
        fill="white"
      />
      <path
        d="M66.6232 66.0286C66.6395 66.4203 66.6354 66.8181 66.7334 67.1996C66.8292 67.5811 67.0414 67.9503 67.3862 68.1421C67.1842 67.3812 67.2923 66.5774 67.4045 65.7981C67.4718 65.3248 67.5392 64.8515 67.6065 64.3783C67.6289 64.213 67.6554 64.0417 67.7513 63.907C67.8472 63.7724 68.0308 63.6806 68.1818 63.7499C67.9798 63.8703 67.7187 63.7092 67.5963 63.5092C67.4739 63.3093 67.427 63.0665 67.2821 62.8829C67.0088 62.5321 66.4253 62.4545 66.0234 62.5484C66.1438 63.7112 66.5763 64.825 66.6232 66.0286Z"
        fill="#E5796E"
      />
      <path
        d="M66.6232 66.0286C66.6395 66.4203 66.6354 66.8181 66.7334 67.1996C66.8292 67.5811 67.0414 67.9503 67.3862 68.1421C67.1842 67.3812 67.2923 66.5774 67.4045 65.7981C67.4718 65.3248 67.5392 64.8515 67.6065 64.3783C67.6289 64.213 67.6554 64.0417 67.7513 63.907C67.8472 63.7724 68.0308 63.6806 68.1818 63.7499C67.9798 63.8703 67.7187 63.7092 67.5963 63.5092C67.4739 63.3093 67.427 63.0665 67.2821 62.8829C67.0088 62.5321 66.4253 62.4545 66.0234 62.5484C66.1438 63.7112 66.5763 64.825 66.6232 66.0286Z"
        fill="#E5796E"
      />
      <g opacity="0.5">
        <path
          d="M66.6232 66.0286C66.6395 66.4203 66.6354 66.8181 66.7334 67.1996C66.8292 67.5811 67.0414 67.9503 67.3862 68.1421C67.1842 67.3812 67.2923 66.5774 67.4045 65.7981C67.4718 65.3248 67.5392 64.8515 67.6065 64.3783C67.6289 64.213 67.6554 64.0417 67.7513 63.907C67.8472 63.7724 68.0308 63.6806 68.1818 63.7499C67.9798 63.8703 67.7187 63.7092 67.5963 63.5092C67.4739 63.3093 67.427 63.0665 67.2821 62.8829C67.0088 62.5321 66.4253 62.4545 66.0234 62.5484C66.1438 63.7112 66.5763 64.825 66.6232 66.0286Z"
          fill="white"
        />
      </g>
      <path
        d="M63.2952 62.8834C63.1626 62.7876 63.1198 62.6121 63.081 62.455C63.0423 62.2959 62.9851 62.1225 62.8423 62.043C62.2161 62.4408 62.5588 63.6056 61.9243 63.9912C61.8019 64.0666 61.6449 64.1074 61.5775 64.2339C61.5163 64.3482 61.5551 64.4991 61.6449 64.593C61.7346 64.6868 61.8631 64.7337 61.9917 64.7582C62.4955 64.848 63.0259 64.5909 63.3279 64.1768C63.5767 63.8361 63.7481 63.2833 63.6257 62.8773C63.5257 62.9324 63.3891 62.9528 63.2952 62.8834Z"
        fill="#E5796E"
      />
      <path
        d="M56.7808 70.5118C56.7686 70.5546 56.7604 70.6097 56.7972 70.6383C56.8502 70.6831 56.9216 70.6138 56.9624 70.5566C57.2256 70.1833 57.7458 70.014 58.1782 70.1629C58.3435 70.1588 58.3986 69.9079 58.2904 69.7835C58.1823 69.659 57.9987 69.6366 57.8335 69.6366C57.6682 69.6366 57.4908 69.6448 57.352 69.557C57.1807 69.4489 57.1134 69.2306 57.1562 69.043C57.044 69.5346 56.9073 70.0222 56.7808 70.5118Z"
        fill="#E5796E"
      />
      <g opacity="0.5">
        <path
          d="M63.2952 62.8834C63.1626 62.7876 63.1198 62.6121 63.081 62.455C63.0423 62.2959 62.9851 62.1225 62.8423 62.043C62.2161 62.4408 62.5588 63.6056 61.9243 63.9912C61.8019 64.0666 61.6449 64.1074 61.5775 64.2339C61.5163 64.3482 61.5551 64.4991 61.6449 64.593C61.7346 64.6868 61.8631 64.7337 61.9917 64.7582C62.4955 64.848 63.0259 64.5909 63.3279 64.1768C63.5767 63.8361 63.7481 63.2833 63.6257 62.8773C63.5257 62.9324 63.3891 62.9528 63.2952 62.8834Z"
          fill="white"
        />
        <path
          d="M56.7808 70.5118C56.7686 70.5546 56.7604 70.6097 56.7972 70.6383C56.8502 70.6831 56.9216 70.6138 56.9624 70.5566C57.2256 70.1833 57.7458 70.014 58.1782 70.1629C58.3435 70.1588 58.3986 69.9079 58.2904 69.7835C58.1823 69.659 57.9987 69.6366 57.8335 69.6366C57.6682 69.6366 57.4908 69.6448 57.352 69.557C57.1807 69.4489 57.1134 69.2306 57.1562 69.043C57.044 69.5346 56.9073 70.0222 56.7808 70.5118Z"
          fill="white"
        />
      </g>
      <path
        d="M65.0874 62.7274C64.7304 62.6805 64.353 62.6703 64.043 62.4888C63.6533 62.2603 63.3881 61.7727 62.9373 61.7544C62.5374 61.736 62.2396 62.1032 62.0111 62.4337C61.9846 61.9359 62.3518 61.4708 62.8149 61.2852C63.278 61.0995 63.8104 61.1587 64.2735 61.3423C64.7366 61.5259 65.1446 61.8258 65.5403 62.1297C65.6994 62.2521 65.8606 62.3786 65.9687 62.5479C66.4685 63.3415 65.4016 62.7703 65.0874 62.7274Z"
        fill="#E5796E"
      />
      <path
        opacity="0.5"
        d="M65.0874 62.7274C64.7304 62.6805 64.353 62.6703 64.043 62.4888C63.6533 62.2603 63.3881 61.7727 62.9373 61.7544C62.5374 61.736 62.2396 62.1032 62.0111 62.4337C61.9846 61.9359 62.3518 61.4708 62.8149 61.2852C63.278 61.0995 63.8104 61.1587 64.2735 61.3423C64.7366 61.5259 65.1446 61.8258 65.5403 62.1297C65.6994 62.2521 65.8606 62.3786 65.9687 62.5479C66.4685 63.3415 65.4016 62.7703 65.0874 62.7274Z"
        fill="white"
      />
      <path
        d="M58.7065 74.3125C58.7309 74.2676 58.7534 74.2227 58.7738 74.1758C58.7289 74.2064 58.7024 74.2533 58.7065 74.3125Z"
        fill="#E5796E"
      />
      <path
        d="M59.3125 71.1528C59.2717 70.651 59.3431 70.145 59.3227 69.6412C59.3023 69.1373 59.1697 68.6069 58.8025 68.2601C58.2762 67.7644 56.8339 68.0173 57.3174 68.9598C57.452 69.2209 57.7968 69.3556 58.066 69.2393C58.3353 69.121 58.4679 68.7558 58.321 68.5028C58.9045 69.3862 58.8514 70.6428 58.1966 71.4751C58.9432 72.1218 59.1819 73.2826 58.7719 74.1781C58.8596 74.1108 59.0126 74.1026 59.1064 74.174C59.2492 74.2822 59.2961 74.4698 59.3675 74.6351C59.4369 74.8003 59.5715 74.9717 59.7511 74.9594C59.9959 74.3576 59.9143 73.6742 59.7552 73.0459C59.596 72.4176 59.3635 71.7995 59.3125 71.1528Z"
        fill="#E5796E"
      />
      <path
        d="M64.5899 61.695C64.3084 61.4808 63.9759 61.3339 63.625 61.2891L64.5899 61.695Z"
        fill="#E5796E"
      />
      <path
        d="M66.9889 68.0766C66.9114 67.7298 66.7522 67.4075 66.6564 67.0648C66.434 66.2671 66.5727 65.4144 66.4707 64.5923C66.3381 63.5294 65.7853 62.5258 64.955 61.8464L64.5898 61.6914C64.9387 61.9586 65.208 62.336 65.3242 62.7604C65.6058 63.7334 65.6955 64.7514 65.82 65.7592C66.0138 67.3116 66.2973 68.8518 66.6686 70.3716C66.9134 69.629 67.1582 68.8416 66.9889 68.0766Z"
        fill="#E5796E"
      />
      <path
        d="M63.1046 64.4502C63.3576 64.2502 63.4922 63.932 63.5351 63.6117C63.5738 63.3261 63.5453 63.0364 63.5126 62.7508C63.4882 62.8732 63.329 62.9773 63.1923 62.9446C63.0189 62.9038 62.9047 62.7427 62.8068 62.5938C62.7823 62.6794 62.7578 62.7651 62.7313 62.8508C62.7211 62.8039 62.7109 62.759 62.7007 62.7121L62.6048 62.8345C62.7497 63.2445 62.8884 63.7198 62.666 64.0911C62.5579 64.2706 62.3804 64.3971 62.207 64.5154C62.4682 64.7011 62.8517 64.6501 63.1046 64.4502Z"
        fill="#E5796E"
      />
      <path
        d="M63.501 62.6484C63.5051 62.6834 63.5092 62.7163 63.5133 62.7513C63.5195 62.7184 63.5174 62.6834 63.501 62.6484Z"
        fill="#E5796E"
      />
      <path
        d="M62.4335 66.7767C61.7175 65.3711 61.0014 63.9656 60.216 62.5988C59.757 61.7991 59.2695 61.0096 58.6554 60.3221C58.3841 60.0161 57.6028 59.3103 57.1723 59.7754C56.8847 60.0855 57.2621 60.6506 56.9092 60.9851C56.9908 60.9892 57.3886 60.9464 57.4314 60.9994C58.327 62.1071 58.8207 63.531 58.8003 64.955C59.0879 64.7285 59.4816 65.0427 59.7081 65.3324C61.0891 67.1092 62.3825 68.9554 63.5779 70.8608C63.3454 70.0182 63.3413 69.1247 63.0904 68.2863C62.9333 67.76 62.6844 67.2663 62.4335 66.7767Z"
        fill="#E5796E"
      />
      <path
        d="M70.7446 70.2005C71.0873 69.2866 71.3525 68.3482 71.3831 67.3771C71.4096 66.4938 71.2097 65.5778 70.7425 64.823C70.6242 64.6313 70.1346 63.85 69.8653 63.9132C69.3859 64.0274 70.0163 64.8598 70.1244 65.0678C70.5385 65.8532 70.9629 66.6835 70.9363 67.5709C70.9159 68.2543 70.6283 68.8969 70.3978 69.5416C70.2366 69.9904 70.1061 70.4698 70.1101 70.941C70.0755 70.994 70.0428 71.0471 70.0041 71.0981C69.6858 71.5142 69.2391 71.859 68.7229 71.9426C68.9208 71.3347 69.1167 70.7248 69.3145 70.1168C69.3859 69.9006 69.4104 69.6028 69.2839 69.4518C69.3247 69.3682 69.3492 69.2804 69.3472 69.1866C69.3411 69.0193 69.2452 68.8704 69.1738 68.7174C68.9004 68.1299 68.9943 67.4465 69.0595 66.8018C69.1411 66.0062 69.1717 65.1882 68.9392 64.4232C68.7066 63.6582 68.166 62.9483 67.4071 62.6953C67.4724 62.7647 67.5377 62.8361 67.6009 62.9054L67.3439 62.7178C67.503 63.0482 67.6621 63.3808 67.8213 63.7133C67.7621 63.7969 67.7029 63.8806 67.6458 63.9642C67.909 63.8255 68.2456 64.0254 68.3659 64.2988C68.4863 64.5701 68.4537 64.8822 68.4251 65.178C68.2701 66.8284 68.3537 68.4991 68.6658 70.127C68.6352 70.5065 68.5699 70.892 68.3721 71.2164C68.1579 71.5652 67.758 71.8284 67.3521 71.7692C67.4418 71.3776 67.2909 70.9145 66.9583 70.6819C66.5463 71.2531 66.789 72.1405 66.8523 72.7913C66.9481 73.7766 67.1052 74.7558 67.3255 75.7207C67.3888 74.8843 67.5642 74.0561 67.8457 73.2646C68.0681 74.0704 68.2905 74.8762 68.5108 75.682C68.5169 75.4555 68.5271 75.2209 68.6373 75.023C68.7474 74.8251 68.9902 74.6824 69.2003 74.7619C69.3737 74.8272 69.4675 75.0108 69.5369 75.1821C70.1142 76.5673 70.2591 78.1279 69.9469 79.5947C70.2203 79.7477 70.5834 79.562 70.7344 79.2887C70.8853 79.0153 70.8853 78.6848 70.8792 78.3707C70.8384 75.6432 70.7915 72.9218 70.7446 70.2005Z"
        fill="#E5796E"
      />
      <path
        d="M63.828 71.0628C63.6975 71.2913 64.232 72.2011 64.3197 72.4173C64.7685 73.5149 65.2193 74.6124 65.6681 75.7099C65.5192 74.2636 65.1663 72.8396 64.6216 71.4932C64.5318 71.2668 64.0871 70.6079 63.828 71.0628Z"
        fill="#E5796E"
      />
      <path
        d="M64.5259 65.2469C64.4484 65.3631 64.3402 65.506 64.2076 65.4652C64.0832 65.4264 64.0628 65.2632 64.0648 65.1347C64.0771 64.3717 64.0893 63.6067 64.1016 62.8438C63.4855 63.2864 63.565 63.8658 63.5202 64.5247C63.4957 64.9062 63.6058 66.7279 63.3447 66.9503C63.9547 66.4301 64.4708 65.8018 64.8625 65.102C64.7564 65.0123 64.6014 65.1306 64.5259 65.2469Z"
        fill="#E5796E"
      />
      <g opacity="0.5">
        <path
          d="M58.7065 74.3125C58.7309 74.2676 58.7534 74.2227 58.7738 74.1758C58.7289 74.2064 58.7024 74.2533 58.7065 74.3125Z"
          fill="white"
        />
        <path
          d="M59.3125 71.1528C59.2717 70.651 59.3431 70.145 59.3227 69.6412C59.3023 69.1373 59.1697 68.6069 58.8025 68.2601C58.2762 67.7644 56.8339 68.0173 57.3174 68.9598C57.452 69.2209 57.7968 69.3556 58.066 69.2393C58.3353 69.121 58.4679 68.7558 58.321 68.5028C58.9045 69.3862 58.8514 70.6428 58.1966 71.4751C58.9432 72.1218 59.1819 73.2826 58.7719 74.1781C58.8596 74.1108 59.0126 74.1026 59.1064 74.174C59.2492 74.2822 59.2961 74.4698 59.3675 74.6351C59.4369 74.8003 59.5715 74.9717 59.7511 74.9594C59.9959 74.3576 59.9143 73.6742 59.7552 73.0459C59.596 72.4176 59.3635 71.7995 59.3125 71.1528Z"
          fill="white"
        />
        <path
          d="M64.5899 61.695C64.3084 61.4808 63.9759 61.3339 63.625 61.2891L64.5899 61.695Z"
          fill="white"
        />
        <path
          d="M66.9889 68.0766C66.9114 67.7298 66.7522 67.4075 66.6564 67.0648C66.434 66.2671 66.5727 65.4144 66.4707 64.5923C66.3381 63.5294 65.7853 62.5258 64.955 61.8464L64.5898 61.6914C64.9387 61.9586 65.208 62.336 65.3242 62.7604C65.6058 63.7334 65.6955 64.7514 65.82 65.7592C66.0138 67.3116 66.2973 68.8518 66.6686 70.3716C66.9134 69.629 67.1582 68.8416 66.9889 68.0766Z"
          fill="white"
        />
        <path
          d="M63.1046 64.4502C63.3576 64.2502 63.4922 63.932 63.5351 63.6117C63.5738 63.3261 63.5453 63.0364 63.5126 62.7508C63.4882 62.8732 63.329 62.9773 63.1923 62.9446C63.0189 62.9038 62.9047 62.7427 62.8068 62.5938C62.7823 62.6794 62.7578 62.7651 62.7313 62.8508C62.7211 62.8039 62.7109 62.759 62.7007 62.7121L62.6048 62.8345C62.7497 63.2445 62.8884 63.7198 62.666 64.0911C62.5579 64.2706 62.3804 64.3971 62.207 64.5154C62.4682 64.7011 62.8517 64.6501 63.1046 64.4502Z"
          fill="white"
        />
        <path
          d="M63.501 62.6484C63.5051 62.6834 63.5092 62.7163 63.5133 62.7513C63.5195 62.7184 63.5174 62.6834 63.501 62.6484Z"
          fill="white"
        />
        <path
          d="M62.4335 66.7767C61.7175 65.3711 61.0014 63.9656 60.216 62.5988C59.757 61.7991 59.2695 61.0096 58.6554 60.3221C58.3841 60.0161 57.6028 59.3103 57.1723 59.7754C56.8847 60.0855 57.2621 60.6506 56.9092 60.9851C56.9908 60.9892 57.3886 60.9464 57.4314 60.9994C58.327 62.1071 58.8207 63.531 58.8003 64.955C59.0879 64.7285 59.4816 65.0427 59.7081 65.3324C61.0891 67.1092 62.3825 68.9554 63.5779 70.8608C63.3454 70.0182 63.3413 69.1247 63.0904 68.2863C62.9333 67.76 62.6844 67.2663 62.4335 66.7767Z"
          fill="white"
        />
        <path
          d="M70.7446 70.2005C71.0873 69.2866 71.3525 68.3482 71.3831 67.3771C71.4096 66.4938 71.2097 65.5778 70.7425 64.823C70.6242 64.6313 70.1346 63.85 69.8653 63.9132C69.3859 64.0274 70.0163 64.8598 70.1244 65.0678C70.5385 65.8532 70.9629 66.6835 70.9363 67.5709C70.9159 68.2543 70.6283 68.8969 70.3978 69.5416C70.2366 69.9904 70.1061 70.4698 70.1101 70.941C70.0755 70.994 70.0428 71.0471 70.0041 71.0981C69.6858 71.5142 69.2391 71.859 68.7229 71.9426C68.9208 71.3347 69.1167 70.7248 69.3145 70.1168C69.3859 69.9006 69.4104 69.6028 69.2839 69.4518C69.3247 69.3682 69.3492 69.2804 69.3472 69.1866C69.3411 69.0193 69.2452 68.8704 69.1738 68.7174C68.9004 68.1299 68.9943 67.4465 69.0595 66.8018C69.1411 66.0062 69.1717 65.1882 68.9392 64.4232C68.7066 63.6582 68.166 62.9483 67.4071 62.6953C67.4724 62.7647 67.5377 62.8361 67.6009 62.9054L67.3439 62.7178C67.503 63.0482 67.6621 63.3808 67.8213 63.7133C67.7621 63.7969 67.7029 63.8806 67.6458 63.9642C67.909 63.8255 68.2456 64.0254 68.3659 64.2988C68.4863 64.5701 68.4537 64.8822 68.4251 65.178C68.2701 66.8284 68.3537 68.4991 68.6658 70.127C68.6352 70.5065 68.5699 70.892 68.3721 71.2164C68.1579 71.5652 67.758 71.8284 67.3521 71.7692C67.4418 71.3776 67.2909 70.9145 66.9583 70.6819C66.5463 71.2531 66.789 72.1405 66.8523 72.7913C66.9481 73.7766 67.1052 74.7558 67.3255 75.7207C67.3888 74.8843 67.5642 74.0561 67.8457 73.2646C68.0681 74.0704 68.2905 74.8762 68.5108 75.682C68.5169 75.4555 68.5271 75.2209 68.6373 75.023C68.7474 74.8251 68.9902 74.6824 69.2003 74.7619C69.3737 74.8272 69.4675 75.0108 69.5369 75.1821C70.1142 76.5673 70.2591 78.1279 69.9469 79.5947C70.2203 79.7477 70.5834 79.562 70.7344 79.2887C70.8853 79.0153 70.8853 78.6848 70.8792 78.3707C70.8384 75.6432 70.7915 72.9218 70.7446 70.2005Z"
          fill="white"
        />
        <path
          d="M63.828 71.0628C63.6975 71.2913 64.232 72.2011 64.3197 72.4173C64.7685 73.5149 65.2193 74.6124 65.6681 75.7099C65.5192 74.2636 65.1663 72.8396 64.6216 71.4932C64.5318 71.2668 64.0871 70.6079 63.828 71.0628Z"
          fill="white"
        />
        <path
          d="M64.5259 65.2469C64.4484 65.3631 64.3402 65.506 64.2076 65.4652C64.0832 65.4264 64.0628 65.2632 64.0648 65.1347C64.0771 64.3717 64.0893 63.6067 64.1016 62.8438C63.4855 63.2864 63.565 63.8658 63.5202 64.5247C63.4957 64.9062 63.6058 66.7279 63.3447 66.9503C63.9547 66.4301 64.4708 65.8018 64.8625 65.102C64.7564 65.0123 64.6014 65.1306 64.5259 65.2469Z"
          fill="white"
        />
      </g>
      <path
        d="M57.0313 70.3984C56.7947 70.5861 56.5907 70.8146 56.4336 71.0716L57.0313 70.3984Z"
        fill="white"
      />
      <path
        d="M65.506 88.96L63.3762 82.2586C61.377 80.2002 57.705 78.3153 57.3868 75.4654C56.9767 71.8056 56.4137 71.9525 56.4137 71.0427C56.4137 71.01 56.6687 70.5857 56.9767 69.6575C57.0767 69.3556 57.1277 68.915 57.1828 68.5539C57.2399 68.1724 57.5806 67.8909 57.9661 67.9194C58.2252 67.9378 58.4863 68.0357 58.6781 68.1969C59.0494 68.511 59.2371 69.0006 59.2819 69.4841C59.3309 69.9696 59.2534 70.4552 59.1759 70.9366C59.5696 71.6792 59.7919 72.5972 59.9572 73.4213C60.1306 72.7359 60.2489 72.0484 60.4223 71.363C60.4651 71.3364 60.4468 71.2834 60.4876 71.2569C60.1367 70.6204 60.3978 70.6367 59.692 69.2271C58.5067 66.8525 57.2073 64.5738 56.1873 61.5587C56.1057 61.3262 56.0853 60.9345 56.1485 60.6938C56.3872 59.7962 57.3031 59.939 57.7315 60.4224C57.8478 60.5489 57.9355 60.6958 58.0069 60.8508C58.4965 61.9157 59.4982 63.5416 60.2061 64.4759L62.6459 67.7073C62.6459 67.7073 63.3742 67.0239 63.4762 66.7322L63.4782 66.7301C63.5741 66.4384 63.4782 64.1414 63.4782 64.1414C63.4782 64.1414 63.3313 64.582 62.9417 64.582C62.6602 64.582 62.1012 64.7819 61.6647 64.3535C61.3097 64.0047 61.2709 63.4437 61.5402 63.0234L62.4521 61.6016C62.4521 61.6016 63.0865 60.9671 64.0147 61.3078C64.9429 61.6505 65.8711 62.4318 65.8711 62.4318C65.8711 62.4318 66.7035 62.3339 67.4338 62.6256C68.1682 62.9194 68.9781 63.8517 68.9781 63.8517C68.9781 63.8517 69.8104 63.8476 70.2 64.0924C70.2979 64.1536 71.6933 66.0365 71.3404 67.6012C71.1303 68.5335 71.0527 69.8717 70.9548 70.2369L70.9303 79.2537L72.6215 85.2329"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M66.0898 62.75C66.4509 64.0801 66.6366 65.4571 66.6468 66.8341C66.6488 67.0646 66.6447 67.3012 66.7202 67.5195C66.7936 67.7378 66.963 67.9398 67.1874 67.9867"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M68.9746 64.0898C69.5805 65.3669 68.9603 68.2188 69.0052 68.4208C69.0501 68.6207 69.1664 68.8165 69.35 68.9104"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M63.7153 62.5751C63.6439 62.981 63.5848 63.4523 63.5134 63.8582C63.0401 63.4543 62.7382 62.8545 62.6953 62.2344"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M59.8069 73.457C59.66 73.5223 59.5131 73.5856 59.3662 73.6508"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M59.9191 73.8125C59.8477 74.1511 59.8457 74.5041 59.915 74.8447"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M62.4971 70C62.6603 70.2938 62.8235 70.5855 62.9846 70.8792"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M63.4336 66.7831C63.5948 66.5546 63.7579 66.3261 63.9191 66.0977"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M70.2641 70C70.2151 70.1795 70.1661 70.359 70.1172 70.5365"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M69.0762 68.531C69.219 68.0741 69.3618 67.6171 69.5066 67.1602"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M70.5127 66.096C70.7657 65.9491 71.1308 66.0633 71.2553 66.3265"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M67.5811 63.7543C67.9177 63.6564 68.3032 63.7441 68.5643 63.9787"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M58.4951 65.1159C58.8093 64.7671 59.2948 64.5835 59.762 64.6386"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M56.6523 61.2676C56.9441 61.0534 57.3235 60.9657 57.6805 61.0269"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M57.0323 70.3984C56.7956 70.5861 56.5917 70.8146 56.4346 71.0716"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M57.2285 69.4694C57.5508 69.2389 58.0649 69.755 58.3607 69.4919C58.479 69.3878 58.4872 69.2063 58.4607 69.0492C58.4342 68.8941 58.3791 68.7371 58.4015 68.582"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M66.3242 68.0547C66.7159 68.8584 66.7975 69.8091 66.5486 70.67"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M68.6952 69.3125C68.7605 69.694 68.685 70.0979 68.4912 70.4345"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.2"
        d="M48.9696 72.3743C48.9879 72.515 48.9818 72.6599 48.9512 72.7986C48.8186 73.4126 48.4351 75.2017 48.2943 76.1809C48.1271 77.3764 46.1952 81.0769 46.1952 81.0769C46.1952 81.0769 44.4163 83.2883 43.5105 84.4388C43.0658 85.0039 42.362 87.2908 41.7643 89.4695C41.0095 89.241 40.2629 88.9942 39.5203 88.731C38.9063 88.5127 38.2922 88.2822 37.6863 88.0435C36.8336 87.7069 35.7463 87.1724 34.4978 86.489C34.8365 85.2589 35.0629 84.3124 35.0588 84.2573C35.0486 84.1288 35.7851 82.7109 35.7851 82.7109L35.1425 74.2572L34.763 72.9699C34.5651 72.3049 34.4407 71.6195 34.3897 70.934C34.3101 69.8875 34.3979 68.8328 34.6529 67.8067L35.7606 66.1625L36.2787 66.1237L37.8822 63.8838C37.8822 63.8838 38.7492 63.6227 38.9715 64.2755C39.1939 64.9303 38.2494 66.1482 38.2494 66.1482L37.925 68.1617L38.6961 70.0466L39.096 70.1935C39.096 70.1935 39.2306 66.8744 39.1388 66.2114L39.9915 63.182C39.9915 63.182 40.4995 62.1702 40.6566 61.6602C40.8116 61.1522 41.7235 60.6484 42.2478 61.5398C42.2478 61.5398 42.5395 61.9927 42.3294 62.6149C42.1152 63.2371 41.9377 63.7267 41.9377 63.7267C41.9377 63.7267 41.7439 66.293 41.6827 66.3644C41.6215 66.4317 42.0601 70.1854 42.0601 70.1854L42.3947 70.3343L42.513 66.7541L43.2086 63.3901C43.2086 63.3901 43.1515 61.7724 44.2919 61.9682C44.2919 61.9682 44.8263 61.907 45.1303 62.4905C45.4343 63.0719 45.1446 66.9438 45.1446 66.9438L45.4261 70.9463L45.8769 74.0328L46.4073 71.9173C46.4073 71.9173 46.4379 68.8859 48.3515 68.6268C48.3515 68.6268 48.9206 68.5248 49.0369 68.9205C49.1532 69.3143 48.7533 70.1242 48.8105 70.8994C48.8533 71.444 48.9308 72.0581 48.9696 72.3743Z"
        fill="black"
      />
      <path
        d="M48.3893 68.6274C48.3015 68.2235 47.7283 68.2826 47.7283 68.2826C45.8005 68.3969 45.5414 71.4181 45.5414 71.4181L44.8519 73.4867L44.6357 70.3736L44.6581 66.3609C44.6581 66.3609 45.2415 62.5217 44.9804 61.9178C44.7234 61.314 44.1828 61.3344 44.1828 61.3344C43.0608 61.0529 42.9955 62.6706 42.9955 62.6706L42.0489 65.9713L41.6613 69.5311L41.339 69.3577C41.339 69.3577 41.186 65.5817 41.2513 65.5184C41.3166 65.4531 41.7062 62.9072 41.7062 62.9072C41.7062 62.9072 41.9204 62.4339 42.1795 61.8281C42.4365 61.2242 42.1795 60.7489 42.1795 60.7489C41.7246 59.8207 40.778 60.2532 40.5842 60.7489C40.3904 61.2446 39.807 62.2157 39.807 62.2157L38.7258 65.1716C38.7666 65.8387 38.3831 69.1394 38.3831 69.1394L37.9955 68.9619L37.3692 67.0239L37.8445 65.039C37.8445 65.039 38.8788 63.8966 38.7074 63.2275C38.534 62.5604 37.6507 62.7542 37.6507 62.7542L35.882 64.8677H35.3618L34.1337 66.4221C33.8012 67.4258 33.6339 68.4723 33.6339 69.5209C33.6339 70.2084 33.7053 70.8999 33.8522 71.5793L34.1337 72.891V81.3692C34.1337 81.3692 33.2933 82.7279 33.2933 82.8564C33.2933 82.9155 32.9465 83.9865 32.4609 85.3227C34.5764 86.5671 36.3981 87.53 37.6895 88.038C38.2953 88.2787 38.9094 88.5072 39.5255 88.7255C40.3007 86.5488 41.2064 84.2191 41.7062 83.6765C42.6977 82.5973 44.6377 80.5267 44.6377 80.5267C44.6377 80.5267 46.845 76.9832 47.102 75.8041C47.3162 74.8371 47.8323 73.0827 48.0119 72.4789C48.0527 72.3443 48.071 72.1994 48.0629 72.0566C48.0486 71.7384 48.018 71.1203 48.018 70.5735C48.0139 69.8065 48.4749 69.0293 48.3893 68.6274Z"
        fill="white"
      />
      <path
        d="M35.15 67.7751C35.4784 67.3651 36.1578 67.206 36.5392 67.5671C36.7596 67.7751 36.833 68.0893 36.8881 68.3851C36.9432 68.6809 36.9982 68.9971 37.1961 69.2256C37.392 69.4541 37.7857 69.5438 37.9938 69.3255C38.0203 69.7723 38.0488 70.2191 38.0753 70.6658C38.5527 69.8376 38.7975 68.8788 38.7771 67.9241C38.7669 67.461 38.6976 66.9877 38.8057 66.5369C38.9138 66.086 39.2626 65.6454 39.7278 65.625C40.2418 65.6025 40.6478 66.1023 40.7478 66.6083C40.8457 67.1142 40.7314 67.6323 40.6988 68.1464C40.6519 68.9298 40.8049 69.7254 41.1415 70.4333C41.2496 70.215 41.3577 69.9967 41.4658 69.7764C41.5637 70.215 41.6596 70.6536 41.7576 71.0922C41.8412 70.1252 41.9269 69.1603 42.0105 68.1933C42.035 67.92 42.0595 67.6385 42.188 67.3977C42.3145 67.155 42.5695 66.9591 42.8428 66.9857C43.21 67.0224 43.4222 67.4141 43.5446 67.7629C44.4646 70.3619 44.0852 73.2179 43.6956 75.9474C43.9506 75.9923 44.1648 75.7352 44.23 75.4843C44.2933 75.2334 44.2708 74.96 44.3667 74.7193C44.4626 74.4786 44.7584 74.2787 44.9767 74.4174C45.299 74.6193 45.0726 75.2456 45.4112 75.419C45.5152 74.6112 45.8376 73.8339 46.3353 73.1893C46.5618 72.8955 46.9004 72.6038 47.2594 72.6977C47.5267 72.767 47.7021 73.0404 47.7409 73.3137C47.7796 73.5871 48.1754 72.4569 48.1081 72.7242C48.2631 71.1513 47.953 70.9841 48.1081 69.4112C48.1366 69.1277 48.5956 68.634 48.3998 68.4259C48.2142 68.228 47.6593 67.9383 47.4124 68.0526C47.1656 68.1668 46.3639 68.5646 46.2048 68.7849C45.2031 70.1681 45.2704 72.1734 44.9583 73.8543C44.6931 71.2921 44.4279 68.687 44.8971 66.1554C45.1562 64.758 45.6335 63.3035 45.1827 61.955C44.9767 61.341 44.43 60.7249 43.7914 60.8412C43.2774 60.935 42.9652 61.4552 42.7571 61.9346C42.0554 63.5462 41.7433 65.2965 41.4352 67.0285C41.8188 65.2863 42.2023 63.5442 42.5858 61.802C42.6858 61.3491 42.7857 60.882 42.7041 60.425C42.6225 59.9681 42.3104 59.5213 41.8555 59.4254C41.4046 59.3316 40.9579 59.5968 40.6192 59.9069C39.4075 61.0166 38.9546 62.7078 38.5609 64.3031C38.6996 63.8869 38.8403 63.4544 38.7975 63.0179C38.7547 62.5813 38.4772 62.1345 38.0468 62.0407C37.4919 61.9183 36.986 62.414 36.7432 62.9281C36.4984 63.4422 36.3781 64.0317 35.9905 64.4479C35.7069 64.1297 35.1745 64.148 34.8175 64.3826C34.4625 64.6193 34.2463 65.013 34.0729 65.4026C33.4344 66.8347 33.161 68.4259 33.2834 69.9885C33.5649 69.3623 34.2748 68.9563 34.9582 69.0359C34.9174 68.6891 34.8766 68.3402 34.8358 67.9934"
        fill="#E5796E"
      />
      <path
        d="M36.4934 71.0979C36.4771 71.355 36.4587 71.612 36.4424 71.8711C36.5219 71.6569 36.8361 71.5773 37.0075 71.7283C36.9687 71.5651 37.0707 71.406 37.136 71.2509C37.2013 71.0959 37.2074 70.8756 37.0564 70.8021C36.8769 70.7144 36.6994 70.9205 36.6056 71.0959C36.5974 71.0327 36.5893 70.9674 36.5811 70.9041L36.4934 71.0979Z"
        fill="#E5796E"
      />
      <path
        d="M39.4189 70.6347C39.2088 70.8754 39.064 71.1732 39.0068 71.4874C39.0946 71.3997 39.1884 71.3119 39.3047 71.2691C39.421 71.2263 39.5699 71.2446 39.6433 71.3446C39.6902 71.4058 39.7066 71.4955 39.7739 71.5323C39.8432 71.569 39.931 71.5241 39.9738 71.4588C40.0146 71.3936 40.0207 71.3119 40.0268 71.2344C40.037 71.0855 40.0452 70.9345 40.0024 70.7917C39.9595 70.6489 39.8534 70.5163 39.7086 70.4857C39.5638 70.4551 39.3904 70.5612 39.3904 70.7101L39.4189 70.6347Z"
        fill="#E5796E"
      />
      <path
        d="M42.2526 71.3364C42.0282 71.6363 41.8813 71.9933 41.8242 72.3625C41.9752 72.3401 42.0996 72.2422 42.22 72.1504C42.3403 72.0565 42.4709 71.9627 42.6219 71.9504C42.7728 71.9382 42.9442 72.0484 42.9381 72.1993C42.9095 72.028 42.936 71.8525 42.9544 71.6812C42.9727 71.5078 42.9809 71.3282 42.9156 71.1671C42.8503 71.0059 42.6953 70.8692 42.5219 70.8794C42.3485 70.8896 42.1996 71.0916 42.2812 71.2446L42.2526 71.3364Z"
        fill="#E5796E"
      />
      <path
        d="M34.4584 72.3609C34.3013 72.6546 34.2197 72.9871 34.2217 73.3217C34.2238 73.1687 34.3686 73.0443 34.5196 73.0218C34.6705 72.9994 34.8235 73.0585 34.9561 73.1381C34.9867 72.9831 35.0173 72.8239 34.9847 72.6709C34.952 72.5179 34.8398 72.369 34.6848 72.3425C34.5298 72.318 34.3584 72.4669 34.4012 72.6179C34.3849 72.5791 34.3686 72.5404 34.3523 72.4996L34.4584 72.3609Z"
        fill="#E5796E"
      />
      <path
        opacity="0.5"
        d="M35.15 67.7751C35.4784 67.3651 36.1578 67.206 36.5392 67.5671C36.7596 67.7751 36.833 68.0893 36.8881 68.3851C36.9432 68.6809 36.9982 68.9971 37.1961 69.2256C37.392 69.4541 37.7857 69.5438 37.9938 69.3255C38.0203 69.7723 38.0488 70.2191 38.0753 70.6658C38.5527 69.8376 38.7975 68.8788 38.7771 67.9241C38.7669 67.461 38.6976 66.9877 38.8057 66.5369C38.9138 66.086 39.2626 65.6454 39.7278 65.625C40.2418 65.6025 40.6478 66.1023 40.7478 66.6083C40.8457 67.1142 40.7314 67.6323 40.6988 68.1464C40.6519 68.9298 40.8049 69.7254 41.1415 70.4333C41.2496 70.215 41.3577 69.9967 41.4658 69.7764C41.5637 70.215 41.6596 70.6536 41.7576 71.0922C41.8412 70.1252 41.9269 69.1603 42.0105 68.1933C42.035 67.92 42.0595 67.6385 42.188 67.3977C42.3145 67.155 42.5695 66.9591 42.8428 66.9857C43.21 67.0224 43.4222 67.4141 43.5446 67.7629C44.4646 70.3619 44.0852 73.2179 43.6956 75.9474C43.9506 75.9923 44.1648 75.7352 44.23 75.4843C44.2933 75.2334 44.2708 74.96 44.3667 74.7193C44.4626 74.4786 44.7584 74.2787 44.9767 74.4174C45.299 74.6193 45.0726 75.2456 45.4112 75.419C45.5152 74.6112 45.8376 73.8339 46.3353 73.1893C46.5618 72.8955 46.9004 72.6038 47.2594 72.6977C47.5267 72.767 47.7021 73.0404 47.7409 73.3137C47.7796 73.5871 48.1754 72.4569 48.1081 72.7242C48.2631 71.1513 47.953 70.9841 48.1081 69.4112C48.1366 69.1277 48.5956 68.634 48.3998 68.4259C48.2142 68.228 47.6593 67.9383 47.4124 68.0526C47.1656 68.1668 46.3639 68.5646 46.2048 68.7849C45.2031 70.1681 45.2704 72.1734 44.9583 73.8543C44.6931 71.2921 44.4279 68.687 44.8971 66.1554C45.1562 64.758 45.6335 63.3035 45.1827 61.955C44.9767 61.341 44.43 60.7249 43.7914 60.8412C43.2774 60.935 42.9652 61.4552 42.7571 61.9346C42.0554 63.5462 41.7433 65.2965 41.4352 67.0285C41.8188 65.2863 42.2023 63.5442 42.5858 61.802C42.6858 61.3491 42.7857 60.882 42.7041 60.425C42.6225 59.9681 42.3104 59.5213 41.8555 59.4254C41.4046 59.3316 40.9579 59.5968 40.6192 59.9069C39.4075 61.0166 38.9546 62.7078 38.5609 64.3031C38.6996 63.8869 38.8403 63.4544 38.7975 63.0179C38.7547 62.5813 38.4772 62.1345 38.0468 62.0407C37.4919 61.9183 36.986 62.414 36.7432 62.9281C36.4984 63.4422 36.3781 64.0317 35.9905 64.4479C35.7069 64.1297 35.1745 64.148 34.8175 64.3826C34.4625 64.6193 34.2463 65.013 34.0729 65.4026C33.4344 66.8347 33.161 68.4259 33.2834 69.9885C33.5649 69.3623 34.2748 68.9563 34.9582 69.0359C34.9174 68.6891 34.8766 68.3402 34.8358 67.9934"
        fill="white"
      />
      <g opacity="0.5">
        <path
          d="M36.4934 71.0979C36.4771 71.355 36.4587 71.612 36.4424 71.8711C36.5219 71.6569 36.8361 71.5773 37.0075 71.7283C36.9687 71.5651 37.0707 71.406 37.136 71.2509C37.2013 71.0959 37.2074 70.8756 37.0564 70.8021C36.8769 70.7144 36.6994 70.9205 36.6056 71.0959C36.5974 71.0327 36.5893 70.9674 36.5811 70.9041L36.4934 71.0979Z"
          fill="white"
        />
        <path
          d="M39.4189 70.6347C39.2088 70.8754 39.064 71.1732 39.0068 71.4874C39.0946 71.3997 39.1884 71.3119 39.3047 71.2691C39.421 71.2263 39.5699 71.2446 39.6433 71.3446C39.6902 71.4058 39.7066 71.4955 39.7739 71.5323C39.8432 71.569 39.931 71.5241 39.9738 71.4588C40.0146 71.3936 40.0207 71.3119 40.0268 71.2344C40.037 71.0855 40.0452 70.9345 40.0024 70.7917C39.9595 70.6489 39.8534 70.5163 39.7086 70.4857C39.5638 70.4551 39.3904 70.5612 39.3904 70.7101L39.4189 70.6347Z"
          fill="white"
        />
        <path
          d="M42.2526 71.3364C42.0282 71.6363 41.8813 71.9933 41.8242 72.3625C41.9752 72.3401 42.0996 72.2422 42.22 72.1504C42.3403 72.0565 42.4709 71.9627 42.6219 71.9504C42.7728 71.9382 42.9442 72.0484 42.9381 72.1993C42.9095 72.028 42.936 71.8525 42.9544 71.6812C42.9727 71.5078 42.9809 71.3282 42.9156 71.1671C42.8503 71.0059 42.6953 70.8692 42.5219 70.8794C42.3485 70.8896 42.1996 71.0916 42.2812 71.2446L42.2526 71.3364Z"
          fill="white"
        />
        <path
          d="M34.4584 72.3609C34.3013 72.6546 34.2197 72.9871 34.2217 73.3217C34.2238 73.1687 34.3686 73.0443 34.5196 73.0218C34.6705 72.9994 34.8235 73.0585 34.9561 73.1381C34.9867 72.9831 35.0173 72.8239 34.9847 72.6709C34.952 72.5179 34.8398 72.369 34.6848 72.3425C34.5298 72.318 34.3584 72.4669 34.4012 72.6179C34.3849 72.5791 34.3686 72.5404 34.3523 72.4996L34.4584 72.3609Z"
          fill="white"
        />
      </g>
      <path
        d="M32.458 85.3306C32.9435 83.9944 33.2903 82.9234 33.2903 82.8642C33.2903 82.7357 34.1308 81.377 34.1308 81.377V72.8988L33.8493 71.5871C33.7024 70.9078 33.631 70.2162 33.631 69.5287C33.631 68.4781 33.7983 67.4336 34.1308 66.43L35.3589 64.8755H35.8791L37.6478 62.762C37.6478 62.762 38.5311 62.5682 38.7045 63.2353C38.8779 63.9065 37.8416 65.0468 37.8416 65.0468L37.3662 67.0317L37.9925 68.9697L38.3801 69.1472C38.3801 69.1472 38.7636 65.8465 38.7228 65.1794L39.804 62.2235C39.804 62.2235 40.3875 61.2524 40.5813 60.7567C40.7751 60.261 41.7237 59.8285 42.1766 60.7567C42.1766 60.7567 42.4336 61.23 42.1766 61.8359C41.9175 62.4397 41.7033 62.915 41.7033 62.915C41.7033 62.915 41.3157 65.4609 41.2484 65.5262C41.1831 65.5895 41.3361 69.3655 41.3361 69.3655L41.6584 69.5389L42.046 65.9791L42.9926 62.6784C42.9926 62.6784 43.0578 61.0607 44.1798 61.3422C44.1798 61.3422 44.7184 61.3197 44.9775 61.9256C45.2366 62.5274 44.6552 66.3687 44.6552 66.3687L44.6327 70.3814L44.849 73.4945L45.5385 71.4259C45.5385 71.4259 45.7976 68.4047 47.7254 68.2904C47.7254 68.2904 48.2986 68.2313 48.3863 68.6352C48.472 69.0371 48.011 69.8143 48.011 70.5916C48.011 71.1383 48.0416 71.7543 48.0558 72.0746C48.064 72.2174 48.0477 72.3602 48.0048 72.4969C47.8253 73.0987 47.3092 74.8551 47.095 75.8221C46.838 77.0012 44.6307 80.5447 44.6307 80.5447C44.6307 80.5447 42.6906 82.6153 41.6992 83.6945C41.1994 84.2371 40.2936 86.5668 39.5184 88.7435"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M38.3434 69.4648C38.4556 69.8667 38.3414 70.3257 38.0537 70.6276L38.3434 69.4648Z"
        fill="white"
      />
      <path
        d="M38.3434 69.4648C38.4556 69.8667 38.3414 70.3257 38.0537 70.6276"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M35.0547 72.3176C35.3362 71.8831 35.6075 71.2874 35.532 70.7754C35.3852 69.7738 34.9282 68.6211 35.1342 67.6297C35.2648 66.9973 35.3974 66.3629 35.528 65.7305"
        fill="white"
      />
      <path
        d="M35.0547 72.3176C35.3362 71.8831 35.6075 71.2874 35.532 70.7754C35.3852 69.7738 34.9282 68.6211 35.1342 67.6297C35.2648 66.9973 35.3974 66.3629 35.528 65.7305"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M43.1885 62.8557C43.521 62.768 43.8739 62.7701 44.2064 62.8578C44.2105 62.7639 44.2146 62.6681 44.2187 62.5742"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M40.5098 61.5798C40.7056 61.7206 40.981 61.739 41.1932 61.6268C41.4053 61.5146 41.5461 61.2759 41.54 61.0352"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M47.8823 68.6641C47.3151 68.7926 46.8929 69.3781 46.9459 69.9554C47.1132 70.0043 47.2784 70.0553 47.4457 70.1043"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M41.3183 68.9102C41.3408 69.2529 41.3 70.0709 41.3224 70.4136L41.3183 68.9102Z"
        fill="white"
      />
      <path
        d="M41.3183 68.9102C41.3408 69.2529 41.3 70.0709 41.3224 70.4136"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M41.6928 69.3867C41.652 69.9477 41.6112 70.5087 41.5684 71.0677C41.5724 70.9963 41.5745 70.9249 41.5786 70.8535"
        fill="white"
      />
      <path
        d="M41.6928 69.3867C41.652 69.9477 41.6112 70.5087 41.5684 71.0677C41.5724 70.9963 41.5745 70.9249 41.5786 70.8535"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M44.8069 74.1133C44.9558 74.7273 44.8885 75.3903 44.6172 75.9615L44.8069 74.1133Z"
        fill="white"
      />
      <path
        d="M44.8069 74.1133C44.9558 74.7273 44.8885 75.3903 44.6172 75.9615"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M39.6346 71.1719C39.1899 71.6594 39.2552 72.8284 39.5693 73.473"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M42.9207 71.9805C42.9309 72.5068 42.7391 73.0351 42.376 73.4758"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M36.3943 71.4062C36.3209 71.8959 36.431 72.412 36.6983 72.8281"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M34.5018 72.9297C34.4794 73.3152 34.5936 73.7049 34.816 74.019"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M37.0967 63.5269C37.3272 63.4147 37.625 63.4636 37.8107 63.6411C37.8943 63.531 37.978 63.4188 38.0636 63.3086"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M39.1895 65.0251C39.5261 64.8109 40.0197 64.8946 40.2686 65.2087"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M42.458 66.0432C42.8211 65.8779 43.2597 65.8881 43.6167 66.0676"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M35.1855 67.7531C35.3977 67.388 35.8363 67.1697 36.2545 67.2227"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M33.8164 69.7067C33.8225 69.4435 34.0388 69.1987 34.2999 69.1641"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M86.3816 55.0444C91.0516 55.0444 94.8374 51.2586 94.8374 46.5886C94.8374 41.9186 91.0516 38.1328 86.3816 38.1328C81.7116 38.1328 77.9258 41.9186 77.9258 46.5886C77.9258 51.2586 81.7116 55.0444 86.3816 55.0444Z"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.2"
        d="M95.9529 46.8119C94.1496 49.7679 93.509 49.3701 87.3604 52.3159C84.2392 53.8112 81.2221 49.0029 83.2621 44.0681C83.362 43.8274 84.2433 42.6095 84.2433 42.6095C84.6146 40.9775 85.9692 39.6107 87.5991 39.2272C89.227 38.8417 91.0508 39.4557 92.1137 40.7491C93.2683 39.727 94.9431 39.3476 96.4344 39.7168C96.5058 39.9249 96.5731 40.1289 96.6384 40.3288C96.6628 40.4063 96.6894 40.4818 96.7118 40.5593C96.7893 40.798 96.8628 41.0367 96.9301 41.2774C97.0647 41.7344 97.1892 42.1934 97.3054 42.6565C96.6261 42.4667 95.9427 42.4627 95.2981 42.7768C94.8472 42.9971 94.4699 43.3603 94.0007 43.5398C93.5315 43.7173 92.8827 43.6173 92.7032 43.1481C92.9296 44.0906 93.919 43.8091 94.8697 43.9947C96.3385 44.2844 96.7118 45.5675 95.9529 46.8119Z"
        fill="black"
      />
      <path
        d="M93.1763 45.3519C93.1763 45.3519 94.69 45.1459 95.4101 45.254C95.8671 45.3213 96.1465 45.5886 96.2812 45.7538C96.3424 45.8313 96.3791 45.9252 96.3852 46.0231L96.4668 47.2063C96.477 47.3409 96.4301 47.4756 96.3363 47.5735C96.0405 47.8815 95.149 48.4425 92.5113 48.6445C88.7964 48.9281 93.1763 45.3519 93.1763 45.3519Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.0688 42.2935C92.4951 42.8239 93.307 44.0255 93.307 45.8901C93.307 47.2997 91.675 52.1141 87.4951 52.6996C83.0703 53.3197 79.5146 49.5335 80.2735 44.9761C80.7998 41.8264 88.5171 37.879 92.0688 42.2935Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.6621 51.6504C90.2077 51.6504 93.0819 48.9296 93.0819 45.5733C93.0819 42.2169 90.2077 39.4961 86.6621 39.4961C83.1165 39.4961 80.2422 42.2169 80.2422 45.5733C80.2422 48.9296 83.1165 51.6504 86.6621 51.6504Z"
        fill="white"
      />
      <path
        d="M86.6512 50.8779C89.5625 50.8779 91.9226 48.6448 91.9226 45.8901C91.9226 43.1355 89.5625 40.9023 86.6512 40.9023C83.74 40.9023 81.3799 43.1355 81.3799 45.8901C81.3799 48.6448 83.74 50.8779 86.6512 50.8779Z"
        fill="#242424"
      />
      <path
        d="M93.0819 45.5733C93.0819 42.2175 90.2076 39.4961 86.6621 39.4961C83.1165 39.4961 80.2422 42.2175 80.2422 45.5733"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M91.3887 49.6869C92.4413 48.6057 93.0819 47.1613 93.0819 45.5742"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.167 49.9102C83.3257 50.9873 84.9128 51.6503 86.6632 51.6503C87.7382 51.6503 88.7521 51.3994 89.6436 50.9567"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.2412 48.8281C81.3249 48.9526 81.4146 49.075 81.5085 49.1953"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.2422 45.5742C80.2422 46.5024 80.4625 47.3796 80.8542 48.1671"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96.0858 47.2383C96.0858 47.2383 94.9414 46.4386 93.085 47.1628L96.0858 47.2383Z"
        fill="white"
      />
      <path
        d="M96.0858 47.2383C96.0858 47.2383 94.9414 46.4386 93.085 47.1628"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.1001 47.793C94.6615 47.9235 93.9271 48.0724 92.7256 48.1663L95.1001 47.793Z"
        fill="white"
      />
      <path
        d="M95.1001 47.793C94.6615 47.9235 93.9271 48.0724 92.7256 48.1663"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.6938 47.5391C95.6938 47.5391 95.6244 47.6003 95.4082 47.6859L95.6938 47.5391Z"
        fill="white"
      />
      <path
        d="M95.6938 47.5391C95.6938 47.5391 95.6244 47.6003 95.4082 47.6859"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96.7119 40.5605C96.6895 40.4829 96.663 40.4075 96.6385 40.3299C96.2488 39.1223 95.747 37.7963 95.137 36.3968C95.0248 36.1377 94.9065 35.8746 94.7882 35.6094C94.7413 35.6135 94.6964 35.6175 94.6515 35.6216C94.066 35.6808 93.45 35.7542 92.9685 36.0867C92.485 36.4254 92.1994 37.121 92.5116 37.6208C92.8176 38.1165 93.6193 38.3919 93.4928 38.957C92.1852 39.6935 90.5899 39.6078 89.1354 39.9791C88.2602 40.2014 87.432 40.5951 86.7057 41.1255C86.7037 41.1255 86.7037 41.1276 86.7016 41.1276C86.4711 41.301 86.2488 41.4846 86.0407 41.6825C85.9489 41.7702 85.853 41.8661 85.7714 41.9721C85.7694 41.9742 85.7694 41.9742 85.7694 41.9762C85.649 42.1292 85.5572 42.3006 85.5388 42.4944C85.4878 43.0391 85.9836 43.4103 86.5119 43.647C86.6098 43.6919 86.6037 43.8326 86.5038 43.8673C86.159 44.006 85.8224 44.1672 85.5511 44.4181C85.549 44.4181 85.547 44.4201 85.545 44.4222C85.3777 44.5731 85.5144 44.8567 85.7428 44.8261C85.7673 44.822 85.7979 44.82 85.8244 44.8179C86.0488 44.8016 86.259 44.8281 86.4405 44.8914C86.7526 45.0015 86.9709 45.2137 86.9934 45.4748C87.026 45.8889 86.5548 46.2623 85.9428 46.3092C85.7938 46.3235 85.9081 46.5009 86.1264 46.5377C86.5609 46.6152 87.0036 46.5315 87.432 46.4316C87.944 46.3092 88.4907 46.1317 88.7804 45.6931C88.9028 45.5075 88.9395 45.2647 88.9028 45.0444C88.8518 44.7425 88.6621 44.4793 88.3602 44.4487C89.3067 44.3365 90.2451 44.1488 91.159 43.8877H91.1611L91.4487 43.8C91.7221 43.7184 92.0097 43.6184 92.2382 43.4552C92.381 43.3532 92.4993 43.2329 92.583 43.0758C92.7951 42.6657 92.4952 42.017 92.0424 42.1027C93.3582 41.5866 94.7494 41.2847 96.0795 40.8093C96.2917 40.7318 96.5038 40.6502 96.7119 40.5605Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M86.6263 22.9156C85.3941 24.011 83.9865 24.9413 82.5667 25.7797C75.139 30.1739 66.7485 32.8055 58.2132 34.0886C49.6798 35.3718 40.9874 35.333 32.3868 34.6252C30.6977 34.4864 28.98 34.3151 27.4275 33.6337C26.1117 33.0544 24.9183 32.0466 24.3594 30.743C26.2219 28.6214 27.9539 26.4754 29.8817 24.4496C30.3407 23.9662 30.8099 23.4908 31.2933 23.0237C31.7013 22.634 32.1155 22.2505 32.5459 21.8752C33.0375 21.4427 33.5435 21.0204 34.0739 20.6124C34.7981 20.0494 35.561 19.5088 36.377 18.9926C36.5769 18.8641 36.7748 18.7397 36.9747 18.6173C57.3156 5.9754 72.2871 10.1023 82.275 18.6173C83.0277 19.2558 83.754 19.9229 84.4496 20.6124C84.8739 21.0224 85.284 21.4468 85.6818 21.8752C85.7267 21.92 85.7675 21.967 85.8103 22.0159C86.0898 22.3138 86.3611 22.6136 86.6263 22.9156Z"
        fill="black"
      />
      <path
        d="M87.43 20.8887L18.9941 21.2008L20.0284 19.6504C20.5262 18.9038 21.3626 18.457 22.2602 18.457H84.1864C84.9983 18.457 85.7674 18.8242 86.2774 19.4566L87.43 20.8887Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.4056 48.8312H50.6561C46.8086 48.8312 43.6895 45.712 43.6895 41.8646V38.115C43.6895 34.2676 46.8086 31.1484 50.6561 31.1484H54.4056C58.253 31.1484 61.3722 34.2676 61.3722 38.115V41.8646C61.3722 45.712 58.253 48.8312 54.4056 48.8312Z"
        fill="#757575"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.9014 41.4844V43.9977C46.9014 44.7871 47.5399 45.4257 48.3294 45.4257H56.9524C57.7378 45.4257 58.3723 44.7912 58.3804 44.0079C58.3906 42.8777 58.4518 41.4844 58.4518 41.4844H46.9014Z"
        fill="#999999"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.4624 42.324H28.0316C27.4991 42.324 27.0218 41.9976 26.828 41.5018L19.0494 21.5384C18.8454 21.0162 19.231 20.4531 19.792 20.4531H86.702C87.263 20.4531 87.6485 21.0162 87.4445 21.5384L79.666 41.5018C79.4722 41.9955 78.9948 42.324 78.4624 42.324Z"
        fill="#BFBFBF"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M78.8358 40.5828H27.5359L20.4775 21.7148H85.8616L78.8358 40.5828Z" fill="#242424" />
      <path d="M58.3923 42.2969H46.9561V43.0802H58.3923V42.2969Z" fill="#242424" />
      <path
        d="M71.3426 39.7727H35.1163C34.9164 39.7727 34.7267 39.6829 34.692 39.5707L29.5389 23.1997C29.4818 23.0161 29.6409 22.8672 29.898 22.8672H76.5589C76.816 22.8672 76.9751 23.0161 76.9179 23.1997L71.7649 39.5707C71.7302 39.6829 71.5405 39.7727 71.3426 39.7727Z"
        fill="#E5796E"
      />
      <path d="M71.208 39.4017H35.251L30.8711 25.0156H75.5879L71.208 39.4017Z" fill="#242424" />
      <path
        d="M40.4135 28.5898H33.606C33.4387 28.5898 33.3265 28.6796 33.3592 28.7918C33.3918 28.902 33.553 28.9938 33.7182 28.9938H40.4869C40.6542 28.9938 40.7725 28.904 40.7542 28.7918C40.7338 28.6796 40.5808 28.5898 40.4135 28.5898Z"
        fill="white"
      />
      <path
        d="M40.6395 29.832H34.85C34.6847 29.832 34.5746 29.9197 34.6031 30.0279C34.6317 30.136 34.7888 30.2217 34.954 30.2217H40.7109C40.8741 30.2217 40.9924 30.1339 40.9741 30.0279C40.9557 29.9197 40.8047 29.832 40.6395 29.832Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M40.8591 31.0312H34.2903C34.1271 31.0312 34.021 31.1149 34.0496 31.2189C34.0781 31.323 34.2332 31.4066 34.3943 31.4066H40.9264C41.0876 31.4066 41.2038 31.323 41.1855 31.2189C41.1692 31.1169 41.0223 31.0312 40.8591 31.0312Z"
        fill="white"
      />
      <path
        d="M41.0717 32.1914H37.214C37.0549 32.1914 36.9447 32.273 36.9692 32.373C36.9937 32.4729 37.1426 32.5545 37.3017 32.5545H41.139C41.2981 32.5545 41.4123 32.4729 41.394 32.373C41.3756 32.273 41.2308 32.1914 41.0717 32.1914Z"
        fill="white"
      />
      <path
        d="M41.2767 33.3086H34.9282C34.7711 33.3086 34.6671 33.3882 34.6936 33.484C34.7221 33.5799 34.869 33.6595 35.0261 33.6595H41.3399C41.4949 33.6595 41.6092 33.582 41.5908 33.484C41.5745 33.3882 41.4337 33.3086 41.2767 33.3086Z"
        fill="white"
      />
      <path
        d="M41.4755 34.3945H36.349C36.194 34.3945 36.0899 34.47 36.1164 34.5638C36.1409 34.6577 36.2858 34.7332 36.4388 34.7332H41.5367C41.6897 34.7332 41.7999 34.6577 41.7836 34.5638C41.7693 34.47 41.6306 34.3945 41.4755 34.3945Z"
        fill="white"
      />
      <path
        d="M41.6666 35.4375H36.6237C36.4728 35.4375 36.3687 35.5109 36.3932 35.6027C36.4177 35.6925 36.5585 35.7659 36.7094 35.7659H41.7258C41.8767 35.7659 41.9849 35.6925 41.9685 35.6027C41.9543 35.5109 41.8196 35.4375 41.6666 35.4375Z"
        fill="white"
      />
      <path
        d="M41.853 36.4531H36.3531C36.2042 36.4531 36.1022 36.5245 36.1267 36.6122C36.1512 36.7 36.2899 36.7714 36.4388 36.7714H41.9121C42.061 36.7714 42.1692 36.7 42.1528 36.6122C42.1365 36.5245 42.0039 36.4531 41.853 36.4531Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M42.0348 37.4336H38.4811C38.3342 37.4336 38.2322 37.503 38.2526 37.5886C38.273 37.6743 38.4097 37.7416 38.5545 37.7416H42.0898C42.2367 37.7416 42.3428 37.6723 42.3265 37.5886C42.3122 37.503 42.1816 37.4336 42.0348 37.4336Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M40.1752 27.3008H35.1018C34.9304 27.3008 34.8162 27.3946 34.8468 27.5109C34.8774 27.6272 35.0385 27.719 35.2099 27.719H40.2528C40.4221 27.719 40.5445 27.6251 40.5241 27.5109C40.5016 27.3946 40.3466 27.3008 40.1752 27.3008Z"
        fill="white"
      />
      <path
        d="M39.9291 25.9648H32.8666C32.6932 25.9648 32.5789 26.0628 32.6136 26.1831C32.6483 26.3035 32.8156 26.3994 32.989 26.3994H40.0107C40.1841 26.3994 40.3065 26.3035 40.2861 26.1831C40.2636 26.0628 40.1045 25.9648 39.9291 25.9648Z"
        fill="white"
      />
      <path
        d="M42.2076 38.3828H36.3548C36.21 38.3828 36.1121 38.4501 36.1366 38.5317C36.161 38.6133 36.2957 38.6807 36.4385 38.6807H42.2627C42.4055 38.6807 42.5116 38.6133 42.4973 38.5317C42.481 38.4501 42.3524 38.3828 42.2076 38.3828Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M42.804 29.0429H44.1239L44.0586 28.5391H42.7285L42.804 29.0429Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M42.9865 30.2727H44.284L44.2207 29.7852H42.9131L42.9865 30.2727Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M43.1641 31.4536H44.4391L44.3779 30.9844H43.0947L43.1641 31.4536Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M43.3359 32.6013H44.5905L44.5293 32.1484H43.2686L43.3359 32.6013Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M43.5028 33.7042H44.7349L44.6758 33.2656H43.4375L43.5028 33.7042Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M43.6649 34.7759H44.8746L44.8195 34.3516H43.5996L43.6649 34.7759Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M43.8191 35.8085H45.0105L44.9574 35.3984H43.7559L43.8191 35.8085Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M43.9683 36.8059H45.1413L45.0903 36.4102H43.9092L43.9683 36.8059Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M44.1148 37.7801H45.2695L45.2185 37.3945H44.0557L44.1148 37.7801Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M42.6127 27.7743H43.957L43.8897 27.25H42.5352L42.6127 27.7743Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M42.4146 26.4528H43.7834L43.712 25.9102H42.333L42.4146 26.4528Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M44.2554 38.7189H45.3916L45.3427 38.3477H44.1982L44.2554 38.7189Z"
        fill="white"
      />
      <path
        d="M51.2139 36.6122C51.2119 36.5245 51.3302 36.4531 51.4791 36.4531H71.0264C71.1753 36.4531 71.2752 36.5245 71.2508 36.6122C71.2243 36.7 71.0835 36.7714 70.9366 36.7714H51.4893C51.3383 36.7714 51.2159 36.7 51.2139 36.6122Z"
        fill="white"
      />
      <path
        d="M71.2233 35.7659H60.4011C60.2502 35.7659 60.1359 35.6925 60.1461 35.6027C60.1563 35.513 60.2869 35.4375 60.4379 35.4375H71.3172C71.4681 35.4375 71.5701 35.5109 71.5436 35.6027C71.5171 35.6925 71.3743 35.7659 71.2233 35.7659Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M57.8307 35.7659H54.4647C54.3137 35.7659 54.1934 35.6925 54.1934 35.6027C54.1954 35.513 54.3178 35.4375 54.4708 35.4375H57.8552C58.0061 35.4375 58.1244 35.5109 58.1163 35.6027C58.1102 35.6925 57.9816 35.7659 57.8307 35.7659Z"
        fill="white"
      />
      <path
        d="M64.855 34.7332H49.5877C49.4347 34.7332 49.3061 34.6577 49.3 34.5638C49.2939 34.47 49.4143 34.3945 49.5693 34.3945H64.9183C65.0733 34.3945 65.1835 34.47 65.1651 34.5638C65.1467 34.6577 65.0101 34.7332 64.855 34.7332Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M46.3953 34.3945H47.4826C47.6377 34.3945 47.7682 34.47 47.7764 34.5638C47.7846 34.6577 47.6662 34.7332 47.5132 34.7332H46.43C46.277 34.7332 46.1444 34.6577 46.1342 34.5638C46.126 34.47 46.2423 34.3945 46.3953 34.3945Z"
        fill="white"
      />
      <path
        d="M67.0653 33.488C67.0449 33.5839 66.9021 33.6634 66.745 33.6634H52.3569C52.2019 33.6634 52.0734 33.5859 52.0713 33.488C52.0693 33.3901 52.1958 33.3125 52.3528 33.3125H66.8185C66.9756 33.3105 67.0857 33.3901 67.0653 33.488Z"
        fill="white"
      />
      <path
        d="M46.2806 33.3086H50.3647C50.5218 33.3086 50.6524 33.3882 50.6564 33.484C50.6605 33.5799 50.5361 33.6595 50.381 33.6595H46.3194C46.1644 33.6595 46.0277 33.582 46.0175 33.484C46.0052 33.3882 46.1236 33.3086 46.2806 33.3086Z"
        fill="white"
      />
      <path
        d="M46.1615 32.1914H61.8552C62.0143 32.1914 62.1326 32.273 62.1204 32.373C62.1061 32.4729 61.9674 32.5545 61.8083 32.5545H46.2002C46.0411 32.5545 45.9044 32.4729 45.8922 32.373C45.882 32.273 46.0024 32.1914 46.1615 32.1914Z"
        fill="white"
      />
      <path
        d="M56.3501 31.4066C56.1889 31.4066 56.0624 31.323 56.0665 31.2189C56.0706 31.1149 56.2052 31.0312 56.3684 31.0312H64.6488C64.8099 31.0312 64.9283 31.1149 64.9099 31.2189C64.8915 31.323 64.7467 31.4066 64.5855 31.4066H56.3501Z"
        fill="white"
      />
      <path
        d="M46.0398 31.0312H53.2063C53.3675 31.0312 53.5001 31.1149 53.5001 31.2189C53.5001 31.323 53.3695 31.4066 53.2063 31.4066H46.0786C45.9174 31.4066 45.7767 31.323 45.7665 31.2189C45.7542 31.1169 45.8766 31.0312 46.0398 31.0312Z"
        fill="white"
      />
      <path
        d="M72.8137 30.2217H53.0869C52.9237 30.2217 52.7891 30.1339 52.7891 30.0279C52.7891 29.9197 52.9217 29.832 53.0869 29.832H72.9259C73.0911 29.832 73.1993 29.9197 73.1687 30.0279C73.136 30.1339 72.9769 30.2217 72.8137 30.2217Z"
        fill="white"
      />
      <path
        d="M73.165 28.9938H55.8066C55.6394 28.9938 55.5068 28.904 55.5108 28.7918C55.5149 28.6796 55.6536 28.5898 55.8209 28.5898H73.2813C73.4486 28.5898 73.5587 28.6796 73.5261 28.7918C73.4955 28.904 73.3323 28.9938 73.165 28.9938Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M73.5319 27.719H69.8966C69.7273 27.719 69.611 27.6251 69.6376 27.5109C69.6641 27.3946 69.8252 27.3008 69.9966 27.3008H73.6523C73.8236 27.3008 73.9358 27.3946 73.9012 27.5109C73.8665 27.6272 73.7012 27.719 73.5319 27.719Z"
        fill="white"
      />
      <path
        d="M67.353 27.719H54.0052C53.8359 27.719 53.6972 27.6251 53.6992 27.5109C53.6992 27.3946 53.84 27.3008 54.0114 27.3008H67.4386C67.61 27.3008 67.7304 27.3946 67.7059 27.5109C67.6794 27.6272 67.5223 27.719 67.353 27.719Z"
        fill="white"
      />
      <path
        d="M46.72 37.4336H59.0457C59.1926 37.4336 59.3048 37.503 59.2966 37.5886C59.2885 37.6743 59.162 37.7416 59.0171 37.7416H46.7526C46.6058 37.7416 46.4813 37.6723 46.4711 37.5886C46.463 37.503 46.5731 37.4336 46.72 37.4336Z"
        fill="white"
      />
      <path
        d="M46.8226 38.3828H65.7599C65.9048 38.3828 66.0068 38.4501 65.9904 38.5317C65.9721 38.6133 65.8415 38.6807 65.6987 38.6807H46.8552C46.7124 38.6807 46.588 38.6133 46.5778 38.5317C46.5676 38.4501 46.6778 38.3828 46.8226 38.3828Z"
        fill="white"
      />
      <path
        d="M66.6903 26.3994H57.0493C56.8759 26.3994 56.7392 26.3035 56.7453 26.1831C56.7514 26.0628 56.8963 25.9648 57.0717 25.9648H66.7719C66.9453 25.9648 67.0698 26.0628 67.0453 26.1831C67.0228 26.3014 66.8637 26.3994 66.6903 26.3994Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M54.3147 26.3994H45.5448C45.3714 26.3994 45.2204 26.3035 45.2061 26.1831C45.1919 26.0628 45.3224 25.9648 45.4979 25.9648H54.3209C54.4943 25.9648 54.635 26.0628 54.633 26.1831C54.6289 26.3014 54.4881 26.3994 54.3147 26.3994Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M61.7822 37.4336C61.929 37.4336 62.0372 37.503 62.0249 37.5886C62.0127 37.6743 61.8842 37.7416 61.7373 37.7416H60.7846C60.6377 37.7416 60.5276 37.6723 60.5378 37.5886C60.548 37.503 60.6744 37.4336 60.8213 37.4336H61.7822Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M50.0903 36.6122C50.0944 36.7 49.9781 36.7714 49.8292 36.7714H48.5318C48.3828 36.7714 48.2564 36.7 48.2502 36.6122C48.2441 36.5245 48.3584 36.4531 48.5073 36.4531H49.8129C49.9598 36.4531 50.0862 36.5245 50.0903 36.6122Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M65.7469 32.373C65.7285 32.4729 65.5836 32.5545 65.4245 32.5545H63.9068C63.7476 32.5545 63.6334 32.4729 63.6477 32.373C63.664 32.273 63.8048 32.1914 63.9659 32.1914H65.4919C65.653 32.1914 65.7673 32.273 65.7469 32.373Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M70.4817 33.3086C70.6388 33.3086 70.7449 33.3882 70.7184 33.484C70.6918 33.5799 70.5449 33.6595 70.3899 33.6595H69.1802C69.0252 33.6595 68.917 33.582 68.9395 33.484C68.9619 33.3861 69.1088 33.3086 69.2659 33.3086H70.4817Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M50.6967 30.2217C50.5335 30.2217 50.3968 30.1339 50.3907 30.0279C50.3866 29.9197 50.5172 29.832 50.6824 29.832H51.9697C52.1349 29.832 52.2696 29.9197 52.2716 30.0279C52.2736 30.136 52.141 30.2217 51.9778 30.2217H50.6967Z"
        fill="white"
      />
      <path
        d="M33.1639 23.9403C33.2638 24.2749 33.07 24.5421 32.7355 24.5421C32.3989 24.5421 32.0398 24.2749 31.9317 23.9403C31.8215 23.6017 32.0113 23.3242 32.356 23.3242C32.7008 23.3242 33.0639 23.6017 33.1639 23.9403Z"
        fill="white"
      />
      <path
        d="M34.8236 23.952C34.9134 24.2866 34.7114 24.5538 34.3748 24.5538C34.0382 24.5538 33.6873 24.2866 33.5914 23.952C33.4935 23.6134 33.6914 23.3359 34.0362 23.3359C34.3809 23.3359 34.7338 23.6134 34.8236 23.952Z"
        fill="white"
      />
      <path
        d="M36.5033 23.9403C36.5808 24.2749 36.3707 24.5421 36.0341 24.5421C35.6975 24.5421 35.3568 24.2749 35.2691 23.9403C35.1814 23.6017 35.3894 23.3242 35.7342 23.3242C36.081 23.3242 36.4258 23.6017 36.5033 23.9403Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M20.4775 21.7148L25.9753 36.409L32.6074 21.7148H20.4775Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M29.7529 40.5828L40.7547 21.7148H52.2705L36.079 40.5828H29.7529Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M57.2342 21.625L40.0859 40.5848H42.7277L60.49 21.7168L57.2342 21.625Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M60.6201 40.5828L79.4656 21.7148H82.1258L62.6948 40.5828H60.6201Z"
        fill="white"
      />
      <path
        d="M35.0662 48.7695H30.7618C30.2029 48.7695 29.75 49.2224 29.75 49.7814V51.8744C29.75 52.4334 30.2029 52.8862 30.7618 52.8862H31.8859L32.7386 54.8181L33.9402 52.8862H35.0642C35.6232 52.8862 36.076 52.4334 36.076 51.8744V49.7814C36.0781 49.2224 35.6252 48.7695 35.0662 48.7695Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3174 49.9654C32.3174 49.8552 32.4071 49.7695 32.5275 49.7695C32.6479 49.7695 32.7376 49.8511 32.7376 49.9572C32.7376 50.0735 32.6519 50.1612 32.5275 50.1612C32.4071 50.1612 32.3174 50.0755 32.3174 49.9654ZM32.3623 50.3917H32.6907V51.7912H32.3623V50.3917Z"
        fill="#242424"
      />
      <path
        d="M33.4804 50.3159V50.3995H33.866V50.6627H33.4906V51.7887H33.1622V50.6627H32.9316V50.3995H33.1622V50.3097C33.1622 50.016 33.3376 49.8242 33.662 49.8242C33.7742 49.8242 33.8843 49.8487 33.9578 49.8997L33.866 50.1465C33.817 50.1119 33.7538 50.0894 33.6844 50.0894C33.5518 50.0915 33.4804 50.1669 33.4804 50.3159Z"
        fill="#242424"
      />
      <path
        d="M48.1678 49.0625H43.8634C43.3044 49.0625 42.8516 49.5154 42.8516 50.0743V52.1674C42.8516 52.7263 43.3044 53.1792 43.8634 53.1792H44.9874L45.8402 55.1111L47.0417 53.1792H48.1658C48.7247 53.1792 49.1776 52.7263 49.1776 52.1674V50.0743C49.1796 49.5154 48.7268 49.0625 48.1678 49.0625Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.7687 51.494H43.6712C43.71 51.698 43.8813 51.8286 44.1241 51.8286C44.2812 51.8286 44.4036 51.7796 44.5035 51.6756L44.679 51.8775C44.5525 52.0264 44.3567 52.106 44.1159 52.106C43.6467 52.106 43.3428 51.8041 43.3428 51.3879C43.3428 50.9718 43.6488 50.6719 44.067 50.6719C44.475 50.6719 44.7749 50.9575 44.7749 51.3961C44.7728 51.4246 44.7708 51.4634 44.7687 51.494ZM43.6671 51.2778H44.4607C44.4342 51.0758 44.2791 50.9371 44.0649 50.9371C43.8528 50.9371 43.6977 51.0738 43.6671 51.2778Z"
        fill="#242424"
      />
      <path d="M45.0869 50.1445H45.4154V52.0887H45.0869V50.1445Z" fill="#242424" />
      <path
        d="M45.6846 51.9489L45.8111 51.7C45.9335 51.7816 46.1232 51.8388 46.2986 51.8388C46.5047 51.8388 46.5924 51.7816 46.5924 51.6837C46.5924 51.4165 45.7274 51.6674 45.7274 51.1105C45.7274 50.8453 45.9661 50.6719 46.3435 50.6719C46.5291 50.6719 46.7413 50.7168 46.8678 50.7922L46.7413 51.0411C46.6087 50.9616 46.4741 50.9371 46.3394 50.9371C46.1395 50.9371 46.0457 51.0024 46.0457 51.0942C46.0457 51.3777 46.9106 51.1248 46.9106 51.6735C46.9106 51.9367 46.6699 52.106 46.2762 52.106C46.0436 52.106 45.809 52.0387 45.6846 51.9489Z"
        fill="#242424"
      />
      <path
        d="M48.5041 51.494H47.4066C47.4453 51.698 47.6167 51.8286 47.8594 51.8286C48.0165 51.8286 48.1389 51.7796 48.2389 51.6756L48.4143 51.8775C48.2878 52.0264 48.092 52.106 47.8513 52.106C47.3821 52.106 47.0781 51.8041 47.0781 51.3879C47.0781 50.9718 47.3841 50.6719 47.8023 50.6719C48.2103 50.6719 48.5102 50.9575 48.5102 51.3961C48.5082 51.4246 48.5061 51.4634 48.5041 51.494ZM47.4025 51.2778H48.196C48.1695 51.0758 48.0145 50.9371 47.8003 50.9371C47.5881 50.9371 47.4331 51.0738 47.4025 51.2778Z"
        fill="#242424"
      />
      <path
        d="M60.87 48.9375H56.5655C56.0066 48.9375 55.5537 49.3904 55.5537 49.9493V52.0424C55.5537 52.6013 56.0066 53.0542 56.5655 53.0542H57.6896L58.5423 54.9861L59.7439 53.0542H60.8679C61.4269 53.0542 61.8797 52.6013 61.8797 52.0424V49.9493C61.8818 49.3904 61.4289 48.9375 60.87 48.9375Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.5536 50.4877V50.5714H57.9392V50.8345H57.5638V51.9606H57.2354V50.8345H57.0049V50.5714H57.2354V50.4816C57.2354 50.1879 57.4108 49.9961 57.7352 49.9961C57.8474 49.9961 57.9576 50.0206 58.031 50.0716L57.9392 50.3184C57.8902 50.2837 57.827 50.2613 57.7576 50.2613C57.625 50.2633 57.5536 50.3388 57.5536 50.4877Z"
        fill="#242424"
      />
      <path
        d="M58.0225 51.2629C58.0225 50.8427 58.3366 50.5469 58.7671 50.5469C59.2016 50.5469 59.5137 50.8427 59.5137 51.2629C59.5137 51.6832 59.2016 51.981 58.7671 51.981C58.3366 51.981 58.0225 51.6832 58.0225 51.2629ZM59.1832 51.2629C59.1832 50.9957 59.0057 50.8243 58.7671 50.8243C58.5304 50.8243 58.3529 50.9957 58.3529 51.2629C58.3529 51.5302 58.5304 51.7015 58.7671 51.7015C59.0057 51.7015 59.1832 51.5302 59.1832 51.2629Z"
        fill="#242424"
      />
      <path
        d="M60.6361 50.5469V50.859C60.6075 50.8529 60.583 50.8508 60.5606 50.8508C60.3117 50.8508 60.1546 50.9977 60.1546 51.2833V51.9626H59.8262V50.5632H60.1383V50.7672C60.2342 50.6203 60.4035 50.5469 60.6361 50.5469Z"
        fill="#242424"
      />
      <path
        d="M73.3866 48.7695H69.0822C68.5232 48.7695 68.0703 49.2224 68.0703 49.7814V51.8744C68.0703 52.4334 68.5232 52.8862 69.0822 52.8862H70.2062L71.0589 54.8181L72.2605 52.8862H73.3845C73.9435 52.8862 74.3964 52.4334 74.3964 51.8744V49.7814C74.3984 49.2224 73.9455 48.7695 73.3866 48.7695Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.6748 50.3242H71.8825V50.5853H70.6748V50.3242ZM70.6748 50.9587H71.8825V51.2198H70.6748V50.9587Z"
        fill="#242424"
      />
      <path
        d="M41.6278 46.3438H37.3234C36.7644 46.3438 36.3115 46.7966 36.3115 47.3556V49.4486C36.3115 50.0076 36.7644 50.4605 37.3234 50.4605H38.4474L39.3001 52.3923L40.5017 50.4605H41.6257C42.1847 50.4605 42.6376 50.0076 42.6376 49.4486V47.3556C42.6396 46.7966 42.1867 46.3438 41.6278 46.3438Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.4639 47.2148H39.0901V47.476H38.7923V49.4058H39.0901V49.669H38.4639V47.2148Z"
        fill="#242424"
      />
      <path
        d="M39.9014 49.669V49.4058H40.1972V47.476H39.9014V47.2148H40.5256V49.669H39.9014Z"
        fill="#242424"
      />
      <path
        d="M54.4237 46.1328H50.1193C49.5603 46.1328 49.1074 46.5857 49.1074 47.1447V49.2377C49.1074 49.7967 49.5603 50.2495 50.1193 50.2495H51.2433L52.096 52.1814L53.2976 50.2495H54.4216C54.9806 50.2495 55.4335 49.7967 55.4335 49.2377V47.1447C55.4355 46.5857 54.9826 46.1328 54.4237 46.1328Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.3968 48.226C51.5009 48.2607 51.5519 48.3301 51.5519 48.4933V48.991C51.5519 49.1175 51.6151 49.191 51.7457 49.191H51.8008V49.4541H51.6702C51.3744 49.4541 51.2255 49.3052 51.2255 49.0278V48.4872C51.2255 48.4015 51.1806 48.3607 51.1072 48.3607H51.0215V48.0934H51.1072C51.1806 48.0934 51.2255 48.0547 51.2255 47.967V47.4264C51.2255 47.1489 51.3744 47 51.6702 47H51.8008V47.2611H51.7457C51.6151 47.2611 51.5519 47.3346 51.5519 47.461V47.9588C51.5519 48.12 51.5009 48.1914 51.3968 48.226Z"
        fill="#242424"
      />
      <path
        d="M53.3967 48.0895V48.3568H53.307C53.2356 48.3568 53.1907 48.3955 53.1907 48.4833V49.0239C53.1907 49.3013 53.0377 49.4502 52.7419 49.4502H52.6113V49.1871H52.6664C52.801 49.1871 52.8622 49.1136 52.8622 48.9871V48.4894C52.8622 48.3262 52.9092 48.2568 53.0152 48.2221C52.9112 48.1875 52.8622 48.1181 52.8622 47.9549V47.4571C52.8622 47.3307 52.799 47.2572 52.6664 47.2572H52.6113V46.9961H52.7419C53.0377 46.9961 53.1907 47.145 53.1907 47.4225V47.9631C53.1907 48.0487 53.2356 48.0895 53.307 48.0895H53.3967Z"
        fill="#242424"
      />
      <path
        d="M67.0828 45.707H62.7784C62.2195 45.707 61.7666 46.1599 61.7666 46.7189V48.8119C61.7666 49.3709 62.2195 49.8238 62.7784 49.8238H63.9025L64.7552 51.7556L65.9568 49.8238H67.0808C67.6398 49.8238 68.0926 49.3709 68.0926 48.8119V46.7189C68.0926 46.1599 67.6398 45.707 67.0828 45.707Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.7588 47.2573C64.7588 47.1268 64.8567 47.0391 64.973 47.0391C65.0913 47.0391 65.1872 47.1247 65.1872 47.2573C65.1872 47.3838 65.0893 47.4756 64.973 47.4756C64.8547 47.4736 64.7588 47.3818 64.7588 47.2573ZM65.1892 48.2549C65.1892 48.312 65.177 48.3589 65.128 48.4813L64.9934 48.8506H64.7812L64.8853 48.4487C64.8118 48.4181 64.7629 48.3487 64.7629 48.2549C64.7629 48.1243 64.8547 48.0366 64.975 48.0366C65.0995 48.0366 65.1892 48.1264 65.1892 48.2549Z"
        fill="#242424"
      />
      <path
        d="M50.2569 82.3142H54.5613C55.1202 82.3142 55.5731 81.8613 55.5731 81.3024V79.2093C55.5731 78.6504 55.1202 78.1975 54.5613 78.1975H53.4372L53.1088 76.2656L51.383 78.1975H50.2589C49.7 78.1975 49.2471 78.6504 49.2471 79.2093V81.3024C49.245 81.8613 49.6979 82.3142 50.2569 82.3142Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.7682 79.8221L50.8645 80.1607L51.7682 80.4994V80.7727L50.5605 80.3035V80.02L51.7682 79.5508V79.8221Z"
        fill="#242424"
      />
      <path d="M52.7234 78.8711H53.0171L52.1522 81.3395H51.8584L52.7234 78.8711Z" fill="#242424" />
      <path
        d="M54.2858 80.0181V80.3017L53.0781 80.7709V80.4975L53.9818 80.1589L53.0781 79.8202V79.5469L54.2858 80.0181Z"
        fill="#242424"
      />
      <path
        d="M22.8965 67.0642H27.2009C27.7599 67.0642 28.2128 66.6113 28.2128 66.0524V63.9593C28.2128 63.4004 27.7599 62.9475 27.2009 62.9475H26.0769L26.3217 61.0156L24.0226 62.9475H22.8986C22.3396 62.9475 21.8867 63.4004 21.8867 63.9593V66.0524C21.8847 66.6113 22.3376 67.0642 22.8965 67.0642Z"
        fill="white"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1709 65.7363C24.1709 65.6241 24.2607 65.5343 24.3831 65.5343C24.5034 65.5343 24.5891 65.6241 24.5891 65.7363C24.5891 65.8485 24.5034 65.9403 24.3831 65.9403C24.2607 65.9403 24.1709 65.8485 24.1709 65.7363ZM24.1893 64.0859H24.5769L24.5116 65.312H24.2525L24.1893 64.0859Z"
        fill="#242424"
      />
      <path
        d="M24.915 64.5547H26.1227V64.8158H24.915V64.5547ZM24.915 65.1891H26.1227V65.4523H24.915V65.1891Z"
        fill="#242424"
      />
      <path
        d="M91.8059 64.6914C91.8059 65.5319 91.7365 66.3458 91.608 67.1129C91.0164 70.6421 89.16 73.2186 86.9649 73.2186C86.7691 73.2186 86.5712 73.1962 86.3815 73.1574C83.9845 72.6494 82.124 69.0529 82.124 64.6914C82.124 59.9831 84.2925 58.3164 86.9629 58.3164C89.6394 58.3164 91.8059 59.9831 91.8059 64.6914Z"
        fill="white"
      />
      <path
        d="M90.0505 64.7457C90.23 67.2712 89.7955 69.809 89.0693 72.2345C90.893 70.7372 91.7315 68.3851 92.4903 66.1513C93.0411 64.5295 93.5981 62.8567 93.5001 61.1471C93.4002 59.4376 92.4842 57.6587 90.8787 57.059C90.0954 56.7652 89.1815 56.7877 88.4063 57.0998C87.0619 57.6383 87.7983 58.0769 88.3614 59.0439C89.3712 60.7677 89.9097 62.7567 90.0505 64.7457Z"
        fill="#E5796E"
      />
      <path
        opacity="0.5"
        d="M90.0505 64.7457C90.23 67.2712 89.7955 69.809 89.0693 72.2345C90.893 70.7372 91.7315 68.3851 92.4903 66.1513C93.0411 64.5295 93.5981 62.8567 93.5001 61.1471C93.4002 59.4376 92.4842 57.6587 90.8787 57.059C90.0954 56.7652 89.1815 56.7877 88.4063 57.0998C87.0619 57.6383 87.7983 58.0769 88.3614 59.0439C89.3712 60.7677 89.9097 62.7567 90.0505 64.7457Z"
        fill="white"
      />
      <path
        d="M91.8059 64.6914C91.8059 65.5319 91.7365 66.3458 91.608 67.1129C91.0164 70.6421 89.16 73.2186 86.9649 73.2186C86.7691 73.2186 86.5712 73.1962 86.3815 73.1574C83.9845 72.6494 82.124 69.0529 82.124 64.6914C82.124 59.9831 84.2925 58.3164 86.9629 58.3164C89.6394 58.3164 91.8059 59.9831 91.8059 64.6914Z"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M89.5666 69.0234C89.2423 70.1108 88.7078 71.1328 87.9795 72.0018L89.5666 69.0234Z"
        fill="white"
      />
      <path
        d="M89.5666 69.0234C89.2423 70.1108 88.7078 71.1328 87.9795 72.0018"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M89.7204 68.4297C89.6938 68.5439 89.6673 68.6602 89.6367 68.7744"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M89.708 64.6797C89.965 65.765 89.9916 66.9012 89.8039 68.0008L89.708 64.6797Z"
        fill="white"
      />
      <path
        d="M89.708 64.6797C89.965 65.765 89.9916 66.9012 89.8039 68.0008"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M82.124 64.6931C82.124 64.6931 87.6259 62.5184 91.8038 64.6931"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M86.9648 58.3164C86.9648 58.3164 87.5156 60.3564 87.5789 63.6734L86.9648 58.3164Z"
        fill="white"
      />
      <path
        d="M86.9648 58.3164C86.9648 58.3164 87.5156 60.3564 87.5789 63.6734"
        stroke="#242424"
        strokeMiterlimit="10"
      />
      <path
        d="M87.7342 60.8018C87.8056 61.4363 87.6955 61.9769 87.4894 62.0095C87.2834 62.0422 87.059 61.5546 86.9876 60.9202C86.9162 60.2857 87.0263 59.7451 87.2324 59.7125C87.4384 59.6798 87.6628 60.1674 87.7342 60.8018Z"
        fill="#BFBFBF"
        stroke="#242424"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.7944 74.8515H78.344C77.5402 74.8515 76.8792 74.2559 76.7752 73.4827C76.7609 73.4133 76.7568 73.3399 76.7568 73.2644V58.0481C76.7568 57.9746 76.7609 57.9012 76.7752 57.8277C76.8792 57.0546 77.5402 56.4609 78.344 56.4609H96.6468C96.9243 56.4609 97.1834 56.5323 97.4078 56.6568"
        stroke="#242424"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default BuildMvp;
